<template>
  <div id="classDetail" class="Detail el-col-24">
    <!--课时开始-->
    <div class="excision">
      <h4 style="font-weight: bold">{{ chapterName }}</h4>
      <div v-if="!teachingAdd" class="TopBox">
        <el-button
          :disabled="teachings.length - this.showTeachingRange <= 3"
          class="icon icon-youla"
          icon="el-icon-caret-right"
          @click="teachingMove(1)"
        ></el-button>
        <el-button
          :disabled="showTeachingRange < 3"
          class="icon icon-xiangzuola"
          icon="el-icon-caret-left"
          @click="teachingMove(-1)"
        ></el-button>
        <template v-for="(item, i) in teachings">
          <div
            v-if="i >= showTeachingRange && i < showTeachingRange + 3"
            :key="item.TeachingPlanID"
            :class="{ TopBtnCover: i === selTeaching }"
            :title="item.CourseTitle"
            class="TopBtn el-col-7"
            @click="selectTeaching(i)"
          >
            {{ item.CourseTitle }}
          </div>
        </template>
      </div>
      <div class="newBtn" @click="addTeachingBtn">添加课时</div>
      <div v-if="teachings.length > 0 && !teachingAdd" class="newBtn" @click="delTeaching">
        删除课时
      </div>
    </div>
    <div class="content_title">
      <i class="icon icon-shu"></i>
      备课标题
    </div>
    <el-input v-model="teachingFormData.CourseTitle" placeholder="请输入备课标题"></el-input>
    <div class="content_title">
      <i class="icon icon-shu"></i>
      学习目标
    </div>
    <el-input
      v-model="teachingFormData.Knowledge"
      :autosize="{ minRows: 4, maxRows: 6 }"
      placeholder="请录入本课的学习目标"
      type="textarea"
    ></el-input>
    <!-- <div class="content_title">
      <i class="icon icon-shu"></i>
      {{ chapterLevel == 2 ? "上传课时备课文件" : "上传大单元备课文件" }}
    </div>
    <div class="bei_box">
      <div class="bei_top">
        <div
          v-if="
            teachingFormData.FileName != null &&
              teachingFormData.FileName.length > 0
          "
          class="file_li"
        >
          <div
            :style="{ 'background-color': 'green' }"
            class="file_yx file_icon"
          >
            {{ teachingFormData.Extension }}
          </div>
          <div class="file_yx file_name">{{ teachingFormData.FileName }}</div>
          <div class="file_yx file_Mb">{{ teachingFormData.Size }}</div>
          <div class="file_yx file_down">
            <a
              :href="hosturl + teachingFormData.PLessonsFile"
              style="color: #3399FF;"
              target="_blank"
              >打开</a
            >
          </div>
          <div
            class="file_yx file_down"
            @click.prevent="
              downFile(
                hosturl + teachingFormData.PLessonsFile,
                teachingFormData.FileName
              )
            "
          >
            下载
          </div>
        </div>
      </div>
 
      <div class="bei_bottom">
        <div class="btn_file" style="margin-left: 0px;">
          {{
            teachingFormData.FileName != null &&
            teachingFormData.FileName.length > 0
              ? "重新选择文件上传"
              : "选择文件上传"
          }}
          <input
            ref="upChapterFile"
            class="fileBtn"
            type="file"
            @change="uploadPlanConfig"
          />
        </div>
      </div>
    </div> -->

    <div class="submitBox el-col-24">
      <el-button
        :class="{ controlTeachBtn: controlTeachBtn }"
        :disabled="controlTeachBtn"
        class="submit"
        @click="saveTeaching"
      >
        保存
      </el-button>
    </div>
    <!--课时结束-->
    <!--tabs开始-->
    <el-row v-show="teachingFormData.TeachingPlanID !== 0" style="margin-top: 90px">
      <el-col :span="24">
        <el-tabs v-model="activeTab" :before-leave="beforeTabClick">
          <!--公共导航开始-->
          <plan-class-com
            v-if="lessonListShow && teachings.length > 0"
            v-show="lessonListShow2"
            :activeTab="activeTab"
            :plan-class-list="teachings[selTeaching].LessonList"
            :plan-task-list="teachings[selTeaching].TaskLists"
            :sel-plan-info="selPlanInfo"
            @clickPlanLi="clickPlanLi"
            @clickTaskLi="clickTaskLi"
            @ppClassList="ppClassList"
            @cancel-match="cancelMatch"
          ></plan-class-com>
          <!--公共导航结束-->

          <!--*********备课tab  start************-->
          <el-tab-pane class="tab1Class" label="备课" name="classFirst">
            <!--课件开始-->
            <div class="content_title title-first">
              <i class="icon icon-shu"></i>
              教案/课件
            </div>
            <div class="bei_box qualityClass">
              <el-table
                v-show="prepareLessonsData.ResourcesList.length > 0"
                :data="prepareLessonsData.ResourcesList"
                :row-style="{ border: '1px dashed #efefef' }"
                class="bei_top"
                header-row-class-name="tableHeader"
                row-class-name="file_li"
                @cell-click="resourceCellClick"
              >
                <el-table-column align="left" label="名称" prop="ResourcesName" width="300">
                  <template slot-scope="scope">
                    <div class="file_li">
                      <div :style="{ 'background-color': scope.row.Color }" class="file_yx file_icon">
                        {{ scope.row.Extension }}
                      </div>
                      <div class="file_yx file_name">
                        {{ scope.row.ResourcesName }}
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="来源">
                  <template slot-scope="scope">
                    <span v-if="scope.row.isCreate == 1" size="small" type="info">自上传</span>
                    <el-popover v-else placement="top" trigger="hover">
                      <p>分享老师：{{ scope.row.TeacherName }}</p>
                      <p>分享单位: {{ scope.row.SchoolName }}</p>
                      <div slot="reference" class="name-wrapper">
                        <span size="small" type="success">云分享</span>
                      </div>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column label="精品标记">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.QualityMark == 1" effect="dark" size="small" type="info">精品</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="分享范围" min-width="140">
                  <template v-if="scope.row.isCreate == 1" slot-scope="scope">
                    <el-tag
                      v-if="scope.row.SharedScope && scope.row.SharedScope.indexOf('1') != -1"
                      effect="plain"
                      size="small"
                      type="info"
                    >
                      平台
                    </el-tag>
                    <el-tag
                      v-if="scope.row.SharedScope && scope.row.SharedScope.indexOf('2') != -1"
                      effect="plain"
                      size="small"
                      type="info"
                    >
                      区域
                    </el-tag>
                    <el-tag
                      v-if="scope.row.SharedScope && scope.row.SharedScope.indexOf('3') != -1"
                      effect="plain"
                      size="small"
                      type="info"
                    >
                      本校
                    </el-tag>
                    <el-tag
                      v-if="scope.row.SharedScope && scope.row.SharedScope.indexOf('4') != -1"
                      effect="plain"
                      size="small"
                      type="info"
                    >
                      联盟校
                    </el-tag>
                    <el-tag
                      v-if="scope.row.SharedScope && scope.row.SharedScope.indexOf('5') != -1"
                      effect="plain"
                      size="small"
                      type="info"
                    >
                      学科组
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="文件大小" prop="Size"></el-table-column>
                <el-table-column fixed="right" label="操作" width="180">
                  <template slot-scope="scope">
                    <el-button
                      size="medium"
                      style="color: #f56c6c"
                      type="text"
                      @click="delFile(scope.row, scope.$index, 'ResourcesList')"
                    >
                      删除
                    </el-button>
                    <!--<el-button type="text" size="medium" ><a style="color: #409EFF;" target="_blank" :href="scope.row.ResourcesPath">打开</a></el-button>-->
                    <el-button
                      size="medium"
                      style="color: #00be00"
                      type="text"
                      @click.prevent="downFile(scope.row.ResourcesPath, scope.row.ResourcesName)"
                    >
                      下载
                    </el-button>
                    <el-button
                      v-if="scope.row.isCreate == 1 && scope.row.SharedScope"
                      size="medium"
                      type="text"
                      @click="cancelShareFile(scope.row, scope.$index)"
                    >
                      取消分享
                    </el-button>
                    <el-button
                      v-if="scope.row.isCreate == 1 && !scope.row.SharedScope"
                      size="medium"
                      type="text"
                      @click="shareFile(scope.row, scope.$index)"
                    >
                      分享
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="bei_bottom">
                <el-button size="small" type="primary" @click="showSharedResourceAddDialog = true">
                  添加云资源
                </el-button>
                <div class="btn_file">
                  上传备课资源
                  <input
                    id="file"
                    ref="upResources"
                    class="fileBtn"
                    multiple="multiple"
                    type="file"
                    @change="uploadConfig"
                  />
                </div>
              </div>
              <!--打开添加云教案课件页面-->
              <el-dialog
                v-if="showSharedResourceAddDialog"
                :fullscreen="true"
                :visible.sync="showSharedResourceAddDialog"
                title=""
                top="6vh"
                width="96%"
                @close="getBeforeClassData(teachingFormData.TeachingPlanID)"
              >
                <shared-resource
                  :chapter-id="chapterID"
                  :teaching-plan-id="teachingFormData.TeachingPlanID"
                ></shared-resource>
              </el-dialog>
            </div>
            <!--课件结束-->

            <!--优师资源开始-->
            <div class="content_title">
              <i class="icon icon-shu"></i>
              优师资源
            </div>
            <div class="bei_box qualityClass">
              <el-table
                v-show="prepareLessonsData.ClassicCourseRelTeachingPlanList.length > 0"
                :border="false"
                :data="prepareLessonsData.ClassicCourseRelTeachingPlanList"
                header-row-class-name="tableHeader"
                @cell-click="cellClick"
              >
                <el-table-column label="优师资源名称" prop="CourseName" width="300"></el-table-column>
                <el-table-column label="来源" prop="SourceType">
                  <template slot-scope="scope">
                    <span v-if="scope.row.IsCreate == 1">自上传</span>
                    <el-popover v-else placement="top" trigger="hover">
                      <p>分享老师: {{ scope.row.TeacherName }}</p>
                      <p>分享单位: {{ scope.row.SchoolName }}</p>
                      <div slot="reference" class="name-wrapper">云分享</div>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column label="精品标记">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.QualityMark == 1" effect="dark" size="small" type="info">精品</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="分享范围" min-width="140">
                  <template v-if="scope.row.IsCreate == 1" slot-scope="scope">
                    <el-tag
                      v-if="scope.row.SharedScope && scope.row.SharedScope.indexOf('1') != -1"
                      size="small"
                      type="info"
                    >
                      平台
                    </el-tag>
                    <el-tag
                      v-if="scope.row.SharedScope && scope.row.SharedScope.indexOf('2') != -1"
                      size="small"
                      type="info"
                    >
                      区域
                    </el-tag>
                    <el-tag
                      v-if="scope.row.SharedScope && scope.row.SharedScope.indexOf('3') != -1"
                      size="small"
                      type="info"
                    >
                      本校
                    </el-tag>
                    <el-tag
                      v-if="scope.row.SharedScope && scope.row.SharedScope.indexOf('4') != -1"
                      size="small"
                      type="info"
                    >
                      联盟校
                    </el-tag>
                    <el-tag
                      v-if="scope.row.SharedScope && scope.row.SharedScope.indexOf('5') != -1"
                      size="small"
                      type="info"
                    >
                      学科组
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="180">
                  <template slot-scope="scope">
                    <el-button size="medium" type="text" @click.stop="deleteClassicCourseTeachingPlan(scope)">
                      删除
                    </el-button>
                    <el-button
                      v-if="scope.row.IsCreate == 1"
                      size="medium"
                      type="text"
                      @click="openEditQualityDialog(scope)"
                    >
                      编辑
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="bei_bottom btns">
                <el-button size="small" type="primary" @click="showQualityClassAddDialog = true">添加云资源</el-button>
                <!--                <el-button size="small" type="primary" @click="upMyQualityClass.click()">上传我的优师资源</el-button>-->
                <el-button
                  plain
                  size="small"
                  type=""
                  @click="
                    upMyQualityDialog = true;
                    sharedScope = [];
                  "
                >
                  上传优师资源
                </el-button>
              </div>
              <!--打开添加面-->
              <el-dialog
                v-if="showQualityClassAddDialog"
                :fullscreen="true"
                :visible.sync="showQualityClassAddDialog"
                title=""
                top="6vh"
                width="96%"
                @close="getBeforeClassData(teachingFormData.TeachingPlanID)"
              >
                <quality-class
                  :chapter-id="chapterID"
                  :teaching-plan-id="teachingFormData.TeachingPlanID"
                ></quality-class>
              </el-dialog>
            </div>
            <!--优师资源结束-->

            <!--任务单开始-->
            <div class="content_title">
              <i class="icon icon-shu"></i>
              任务单/导学案
            </div>
            <div class="bei_box qualityClass">
              <el-table
                v-show="prepareLessonsData.TaskListViewModelList.length > 0"
                :border="false"
                :data="prepareLessonsData.TaskListViewModelList"
                :highlight-current-row="true"
                header-row-class-name="tableHeader"
                @cell-click="previewTask"
              >
                <el-table-column label="名称" prop="TaskName" width="300"></el-table-column>
                <el-table-column label="来源">
                  <template slot-scope="scope">
                    <span v-if="scope.row.IsCreate == 1" size="small" type="info">自上传</span>
                    <el-popover v-else placement="top" trigger="hover">
                      <p>分享老师：{{ scope.row.TeacherName }}</p>
                      <p>分享单位: {{ scope.row.SchoolName }}</p>
                      <div slot="reference" class="name-wrapper">
                        <span size="small" type="success">云分享</span>
                      </div>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column label="精品标记">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.QualityMark == 1" effect="dark" size="small" type="info">精品</el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="分享范围" min-width="140">
                  <template v-if="scope.row.IsCreate == 1" slot-scope="scope">
                    <el-tag
                      v-if="scope.row.SharedScope && scope.row.SharedScope.indexOf('1') != -1"
                      effect="plain"
                      size="small"
                      type="info"
                    >
                      平台
                    </el-tag>
                    <el-tag
                      v-if="scope.row.SharedScope && scope.row.SharedScope.indexOf('2') != -1"
                      effect="plain"
                      size="small"
                      type="info"
                    >
                      区域
                    </el-tag>
                    <el-tag
                      v-if="scope.row.SharedScope && scope.row.SharedScope.indexOf('3') != -1"
                      effect="plain"
                      size="small"
                      type="info"
                    >
                      本校
                    </el-tag>
                    <el-tag
                      v-if="scope.row.SharedScope && scope.row.SharedScope.indexOf('4') != -1"
                      effect="plain"
                      size="small"
                      type="info"
                    >
                      联盟校
                    </el-tag>
                    <el-tag
                      v-if="scope.row.SharedScope && scope.row.SharedScope.indexOf('5') != -1"
                      effect="plain"
                      size="small"
                      type="info"
                    >
                      学科组
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column label="出题方式" min-width="80" prop="isOnline">
                  <template slot-scope="scope">
                    {{ taskTypes[scope.row.isOnline - 1] }}
                  </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="260">
                  <template slot-scope="scope">
                    <el-button size="medium" type="text" @click="deleteTaskListTeachingPlan(scope.row)">删除</el-button>
                    <el-button
                      v-if="scope.row.IsCreate == 1"
                      size="medium"
                      type="text"
                      @click="editTaskList(scope.row)"
                    >
                      编辑
                    </el-button>
                    <el-button size="medium" type="text" @click="previewTask(scope.row, { property: 'TaskName' })">
                      打印/导出
                    </el-button>
                    <el-button
                      v-if="scope.row.IsCreate == 1 && !scope.row.SharedScope"
                      size="medium"
                      type="text"
                      @click="openShareTaskDialog(scope.row, scope.$index)"
                    >
                      分享
                    </el-button>
                    <el-button
                      v-if="scope.row.IsCreate == 1 && scope.row.SharedScope"
                      size="medium"
                      type="text"
                      @click="cancelShareTask(scope.row, scope.$index)"
                    >
                      取消分享
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div class="bei_bottom btns">
                <el-button size="small" type="primary" @click="showTaskAddDialog = true">添加云任务单</el-button>
                <el-button plain size="small" type="" @click="TaskCreateDialog">创建任务单</el-button>
              </div>
              <!--预览任务单-->
              <el-dialog
                v-if="showPreviewTask"
                :fullscreen="true"
                :visible.sync="showPreviewTask"
                :title="taskInfo.TaskName"
                top="6vh"
                width="96%"
              >
                <!--                <task-view :chapter="chapter" :sel-task-questions="selTaskQuestions" :task-info="taskInfo">
                                </task-view>-->
                <task-detail
                  :chapter="chapter"
                  :questions="selTaskQuestions"
                  :task="taskInfo"
                  :task-index="activeTaskIndex"
                  @edit-task="editTaskList"
                  @delete-task="deleteTaskListTeachingPlan"
                  @share-task="openShareTaskDialog"
                  @cancel-share-task="cancelShareTask"
                ></task-detail>
              </el-dialog>
              <!--添加任务单-->
              <el-dialog
                v-if="showTaskAddDialog"
                :fullscreen="true"
                :visible.sync="showTaskAddDialog"
                style="overflow-x: hidden"
                title=""
                top="6vh"
                width="96%"
                @close="closeTaskAddDialog"
              >
                <task-add :chapter-id="chapterID" :teaching-plan-id="teachingFormData.TeachingPlanID"></task-add>
              </el-dialog>
              <!--创建/编辑任务单-->
              <el-dialog
                v-if="showTaskEditDialog"
                :before-close="closeBefore"
                :close-on-click-modal="true"
                :close-on-press-escape="false"
                :fullscreen="true"
                :visible.sync="showTaskEditDialog"
                custom-class="editTaskDialog"
                title="编辑任务单"
                @close="closeTaskDialog"
                :modal-append-to-body="false"
                :append-to-body="false"
              >
                <task-create 
                  :chapter="chapter" 
                  :taskID="editTaskID" 
                  :taskType="editTaskType" 
                  :teachingPlanID="teachingFormData.TeachingPlanID" 
                  :task="taskData" 
                  :pages="taskPages">
                </task-create>
              </el-dialog>
            </div>
            <!--任务单结束-->
          </el-tab-pane>
          <!--*********备课tab  end************-->

          <!--*********回顾tab  start************-->
          <el-tab-pane label="回顾" name="classIn">
            <div v-show="true" class="InClass">
              <!--课中文件回顾开始-->
              <div class="content_title">
                <i class="icon icon-shu"></i>
                课中文件回顾
              </div>
              <div class="card-carousel-wrapper">
                <div :disabled="atHeadOfList" class="card-carousel--nav__left" @click="moveCarousel(-1)"></div>
                <div class="card-carousel">
                  <div class="card-carousel--overflow-container">
                    <div
                      :style="{
                        transform: 'translateX' + '(' + currentOffset + 'px' + ')',
                      }"
                      class="card-carousel-cards"
                    >
                      <div
                        v-for="(item, i) in lessonImages"
                        :key="i"
                        class="card-carousel--card"
                        @click="imgPopShow(i)"
                      >
                        <img :src="item.ResourcesPath" />
                        <div class="card-carousel--card--footer">
                          <a class="p" @click.stop="DeleteClassFiles(item, i, 'lessonImages')">
                            <i class="el-icon-close"></i>
                          </a>
                          <a :href="item.ResourcesPath" class="p" target="_blank" @click.stop="">
                            <i class="el-icon-download"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div :disabled="atEndOfList" class="card-carousel--nav__right" @click="moveCarousel(1)"></div>
              </div>

              <!-- 直播回放开始-->
              <div class="tableTitle el-col-23">
                <i class="icon icon-shu"></i>
                已录制的直播
              </div>
              <div class="videoList el-col-23">
                <el-table
                  :border="true"
                  :data="lessonSrc.LiveVideoList"
                  :highlight-current-row="true"
                  :stripe="true"
                  header-row-class-name="tableHeader"
                  @cell-click="videoPlay"
                >
                  <el-table-column label="直播名称" prop="ResourcesName"></el-table-column>
                  <el-table-column label="时间" prop="CreateDate" width="300"></el-table-column>
                  <el-table-column label="操作" width="220">
                    <template slot-scope="scope">
                      <!--                      <a class="down" :href="scope.row.ResourcesPath" target="_blank">下载</a>-->
                      <el-button v-if="!scope.row.isRelease" size="small" type="text" @click="issueOnOff(scope)">
                        发布
                      </el-button>
                      <el-button v-if="scope.row.isRelease" size="small" type="text" @click="cancleIssue(scope)">
                        取消发布
                      </el-button>
                      <el-button size="small" type="text" @click="DeleteClassFiles(scope.row, scope.$index, 'Video')">
                        删除
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- 直播回放结束-->

              <!-- 微课录制开始-->
              <div class="tableTitle el-col-23">
                <i class="icon icon-shu"></i>
                已录制的微课
              </div>
              <div class="videoList el-col-23">
                <el-table
                  :border="true"
                  :data="lessonSrc.MinVideoList"
                  :highlight-current-row="true"
                  :stripe="true"
                  header-row-class-name="tableHeader"
                  @cell-click="videoPlay"
                >
                  <el-table-column label="微课名称" prop="ResourcesName"></el-table-column>
                  <el-table-column label="时间" prop="CreateDate" width="300"></el-table-column>
                  <!--
                  <el-table-column width="220" label="申请精品进度状态">
                    <template slot-scope="scope">
                      <el-button v-if="scope.row.State!=-1" type="text" size="small">
                        {{scope.row.State | formatState}}
                      </el-button>
                    </template>
                  </el-table-column>
                  -->
                  <el-table-column label="操作" width="220">
                    <template slot-scope="scope">
                      <span
                        class="down"
                        style="cursor: pointer"
                        target="_blank"
                        @click="downFile(scope.row.ResourcesPath, scope.row.ResourcesName)"
                      >
                        下载
                      </span>
                      <el-button v-if="!scope.row.isRelease" size="small" type="text" @click="issueOnOff(scope)">
                        发布
                      </el-button>
                      <el-button v-if="scope.row.isRelease" size="small" type="text" @click="cancleIssue(scope)">
                        取消发布
                      </el-button>
                      <!--                      <el-button type="text" size="small" @click="issueOnOff(scope)">
                                              发布
                                            </el-button>-->
                      <el-button size="small" type="text" @click="DeleteClassFiles(scope.row, scope.$index, 'Video')">
                        删除
                      </el-button>
                      <el-button
                        v-if="scope.row.State === -1 || scope.row.State === 2"
                        size="small"
                        type="text"
                        @click="ApplyClassicCourse(scope)"
                      >
                        申请精品
                      </el-button>
                      <el-button v-if="scope.row.State === 1" size="small" type="text" @click="CancelBoutique2(scope)">
                        取消精品
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <!-- 微课录制结束-->
            </div>
          </el-tab-pane>
          <!--*********回顾tab  end************-->

          <!--*********自评tab  start************-->
          <el-tab-pane label="自评" name="classAfter">
            <el-row :gutter="20">
              <el-col :span="13" style="text-align: right">
                <div class="content_title title-first">
                  <i class="icon icon-shu"></i>
                  学生自评
                </div>
                <div>
                  <echart-evaluate
                    v-if="echartEvaluateShow"
                    :echart-evaluate-data="echartEvaluateData"
                    :echart-width="echartEvaluateWidth"
                    echart-id="evaluateChart"
                  ></echart-evaluate>
                </div>
                <div class="content_title title-first el-col-24">
                  <i class="icon icon-shu"></i>
                  教师自评
                </div>
                <el-input
                  v-model="evaluateMessage"
                  :autosize="{ minRows: 6, maxRows: 10 }"
                  placeholder="请输入课后自评"
                  style="margin-top: 40px"
                  type="textarea"
                ></el-input>
                <el-button class="evaluateSave" size="small" type="primary" @click="evaluateSave">保存</el-button>
              </el-col>
              <el-col :span="11">
                <div class="content_title title-first">
                  <i class="icon icon-shu"></i>
                  学生自评详情
                </div>
                <el-table :border="true" :data="studentList" header-row-class-name="tableHeader" max-height="530">
                  <el-table-column label="学生姓名" prop="StudentName"></el-table-column>

                  <el-table-column label="掌握情况">
                    <template slot-scope="scope">
                      {{ scope.row.selection | formatSelection }}
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-tab-pane>
          <!--*********自评tab  end************-->

          <!--*********随机练习分析tab  start************-->
          <el-tab-pane class="classChart" label="随机练习分析" name="classChart">
            <exercise-analysis
              v-if="exerciseComShow"
              :exercise-data="exerciseData"
              :lesson-id="selLessonId"
              :resize-num="resizeNum"
              :student-list="studentList"
            ></exercise-analysis>
          </el-tab-pane>
          <!--*********随机练习分析tab  end************-->

          <!--*********任务单分析tab  start************-->
          <el-tab-pane class="classChart" label="任务单分析" name="taskChart">
              <task-analysis
                ref="TaskAnalysis"
                :device-height="deviceHeight"
                :device-width="deviceWidth"
                :lessonID="selLessonId"
                :taskComShow="taskComShow"
                :taskID="taskID"
              ></task-analysis>
          </el-tab-pane>
          <!--*********任务单分析tab  end************-->
        </el-tabs>
      </el-col>
    </el-row>
    <!--tabs结束-->
    <!--优师资源,video-->
    <div v-if="showQualityClassVideo" class="CoverBox el-col-16">
      <div class="title">{{ qualityClassVideo.CourseName }}</div>
      <div class="videops">
        <video autoplay="true" class="video-js videoCover" controls data-setup="{}" preload="auto">
          <!--<source :src="Cover.ResourcesPath" type="video/mp4">-->
          <source :src="qualityClassVideo.VideoPath" type="video/mp4" />
        </video>
      </div>
      <div class="setBen">
        <div class="el-col-8 CoverClose CoverBtn" style="width: 100%" @click="closeQualityClassVideo">
          关闭
        </div>
      </div>
    </div>
    <!--匹配课程对话框开始-->
    <el-dialog :visible.sync="ppkc" center class="tk_pp" overflow="hidden" title="匹配资源" width="25%">
      <div class="tk_top">资源名称</div>
      <div v-for="item in radioArr" :key="item.PlanClassID" class="radioBox">
        <el-radio v-model="ppLessonId" :label="item.PlanClassID">
          {{ item.ClassName }}&nbsp;&nbsp;{{ item.CreateDate }}
        </el-radio>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ppkc = false">取 消</el-button>
        <el-button type="primary" @click="ppClick">确 定</el-button>
      </span>
    </el-dialog>
    <!--匹配课程对话框结束-->

    <!--弹出播放视频开始-->
    <div v-if="Cover.show" class="CoverBox el-col-16">
      <div class="title">{{ Cover.ResourcesName }}</div>
      <div class="videops">
        <video
          v-if="Cover.ResourcesPath.substring(Cover.ResourcesPath.length - 3) === 'flv'"
          :id="'videoCover' + Cover.ResourcesID"
          class="videoCover"
        ></video>
        <video
          v-else
          :id="'videoCover' + Cover.ResourcesID"
          class="video-js videoCover"
          controls
          data-setup="{}"
          preload="auto"
        >
          <source
            v-if="Cover.ResourcesPath.substring(Cover.ResourcesPath.length - 3) === '3u8'"
            :src="Cover.ResourcesPath"
            type="application/x-mpegURL"
          />
          <source
            v-if="Cover.ResourcesPath.substring(Cover.ResourcesPath.length - 3) === 'mp4'"
            :src="Cover.ResourcesPath"
            type="video/mp4"
          />
        </video>
      </div>
      <div class="setBen">
        <a
          v-if="Cover.ResourcesPath.substring(Cover.ResourcesPath.length - 3) !== '3u8'"
          :href="Cover.ResourcesPath"
          class="el-col-8 CoverDown CoverBtn"
          target="_blank"
        >
          下载
        </a>
        
        <div class="el-col-8 CoverClose CoverBtn" @click="closeVideo(Cover)">
          关闭
        </div>
      </div>
    </div>
    <!--弹出播放视频结束-->

    <!--教案课件分享-->
    <el-dialog :visible.sync="shareDialog" center class="tk" title="分享" width="600px">
      <el-form label-width="110px">
        <el-form-item :required="true" label="选择分享范围:">
          <el-checkbox-group v-model="sharedScope">
            <el-checkbox :label="1">平台内</el-checkbox>
            <el-checkbox :label="2">区域内</el-checkbox>
            <el-checkbox :label="3">本校</el-checkbox>
            <el-checkbox :label="4">联盟校</el-checkbox>
            <el-checkbox :label="5">学科组老师</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="是否是精品:">
          <el-checkbox v-model="qualityMark" :false-label="0" :true-label="1">标记精品</el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shareDialog = false">取 消</el-button>
        <el-button type="primary" @click="share">确 定</el-button>
      </span>
    </el-dialog>

    <!--任务单分享-->
    <el-dialog :visible.sync="shareTaskDialog" center class="tk" title="分享" width="600px">
      <el-form label-width="110px">
        <el-form-item :required="true" label="选择分享范围:">
          <el-checkbox-group v-model="sharedScope">
            <el-checkbox :label="1">平台内</el-checkbox>
            <el-checkbox :label="2">区域内</el-checkbox>
            <el-checkbox :label="3">本校</el-checkbox>
            <el-checkbox :label="4">联盟校</el-checkbox>
            <el-checkbox :label="5">学科组老师</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="是否是精品:">
          <el-checkbox v-model="qualityMark" :false-label="0" :true-label="1">标记精品</el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shareTaskDialog = false">取 消</el-button>
        <el-button type="primary" @click="shareTask">确 定</el-button>
      </span>
    </el-dialog>

    <!--权限范围-->
    <el-dialog :visible.sync="issueDialog" center class="tk" title="发布" width="600px">
      <el-row>
        <el-col :span="24">
          <h2 style="font-size: 18px">请选择发布范围</h2>
        </el-col>
        <!-- <el-col :span="24">
          <el-radio-group v-model="issueType" style="margin-top: 15px">
            <el-radio :label="1">校内发布</el-radio>
            <el-radio :label="0">全网发布</el-radio>
          </el-radio-group>
        </el-col> -->
        <el-col v-show="issueType === 1" :span="24">
          <el-select v-model="issueClassValue" multiple placeholder="请选择班级" style="width: 100%; margin-top: 15px">
            <el-option
              v-for="(item, index) in managementClass"
              :key="index"
              :label="item.Remark"
              :value="item.ID"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="24">
          <div style="text-align: center; margin-top: 30px">
            <p>感谢您的发布分享！</p>
            <p>发布后，您的课程文件将会分享给他人，</p>
            <p>他人可对您的课程文件进行观看学习、二次编辑或其他操作等。</p>
          </div>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="issueDialog = false">取 消</el-button>
        <el-button type="primary" @click="issue">确 定</el-button>
      </span>
    </el-dialog>

    <div v-if="lessonImgDialog" class="lessonImgDialog" @click="lessonImgDialog = false">
      <div class="lessonImgCarousel">
        <el-carousel :autoplay="false" :initial-index="carouselIndex" arrow="always" height="720px">
          <el-carousel-item v-for="(item, i) in lessonImages" :key="i">
            <img :src="item.ResourcesPath" alt="" style="width: 100%; max-height: 100%; object-fit: contain" />
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!--优师资源上传窗口开始-->
    <input
      v-show="false"
      id="upMyQualityClass"
      ref="upMyQualityClass"
      accept="video/mp4"
      type="file"
      @change="upQualityClass"
    />
    <el-dialog :visible.sync="upMyQualityDialog" center class="tk upQualityClass" title="优师资源上传" width="600px">
      <el-form label-width="110px">
        <el-form-item :required="true" label="优师资源名称:">
          <el-input v-model="upMyQualityCourseName"></el-input>
        </el-form-item>
        <el-form-item :required="true" label="优师资源视频:">
          <el-button size="small" type="primary" @click="upMyQualityClass.click()">上传(mp4)</el-button>
          <span class="sp">{{ this.upMyQualityE.target && this.upMyQualityE.target.files && this.upMyQualityE.target.files[0] ? this.upMyQualityE.target.files[0].name : "" }}</span>
        </el-form-item>
        <el-form-item :required="true" label="选择分享范围:">
          <el-checkbox-group v-model="sharedScope">
            <el-checkbox :label="1">平台内</el-checkbox>
            <el-checkbox :label="2">区域内</el-checkbox>
            <el-checkbox :label="3">本校</el-checkbox>
            <el-checkbox :label="4">联盟校</el-checkbox>
            <el-checkbox :label="5">学科组老师</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <ul class="msg">
          <li class="title">注意:</li>
          <li>请上传自己授课的视频文件或经授权的视频文件！</li>
          <li>
            上传的优师资源视频将会在所选范围内分享推荐，他人可以观看学习使用您的课程文件。
          </li>
        </ul>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancleUpQualityClass">取 消</el-button>
        <el-button type="primary" @click="submitUpQualityClass">确 定</el-button>
      </span>
    </el-dialog>
    <!--优师资源上传窗口结束-->

    <!--    上传进度开始-->
    <up-load-file-status
      :files-status="filesStatus"
      :up-done="upDone"
      @upFileCancel="upFileCancel"
      @upFileClose="upFileClose"
    ></up-load-file-status>
    <!--    上传进度结束-->

    <!--优师资源编辑窗口开始-->
    <el-dialog
      :visible.sync="editMyQualityDialog"
      center
      class="tk editQualityClass"
      title="编辑优师资源"
      width="600px"
    >
      <el-form label-width="110px">
        <el-form-item :required="true" label="优师资源名称:">
          <el-input v-model="editMyQualityCourseName"></el-input>
        </el-form-item>
        <el-form-item :required="true" label="选择分享范围:">
          <el-checkbox-group v-model="sharedScope">
            <el-checkbox label="1">平台内</el-checkbox>
            <el-checkbox label="2">区域内</el-checkbox>
            <el-checkbox label="3">本校</el-checkbox>
            <el-checkbox label="4">联盟校</el-checkbox>
            <el-checkbox label="5">学科组老师</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancleEditQualityClass">取 消</el-button>
        <el-button type="primary" @click="submitEditQualityClass">确 定</el-button>
      </span>
    </el-dialog>
    <!--优师资源编辑窗口结束-->

    <!--创建任务单窗口开始-->
    <el-dialog
      v-if="showTaskCreateDialog"
      :visible.sync="showTaskCreateDialog"
      center
      class="tk createTask"
      title="创建任务单"
      width="600px"
      @close="closeTaskDialog"
    >
      <el-form label-position="right" label-width="100px" size="small">
        <el-form-item :required="true">
          <label slot="label">名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称：</label>
          <el-input v-model="taskData.TaskName"></el-input>
        </el-form-item>
        <el-form-item>
          <label slot="label">计分制：</label>
          <el-switch v-model="taskData.IsScore"></el-switch>
        </el-form-item>
        <el-form-item :required="true" label="出题方式：">
          <el-radio-group v-model="taskData.isOnline" @change="changeQuestionType">
            <el-radio :label="1" style="line-height: 28px">在线出题</el-radio>
            <el-radio :label="2" style="line-height: 28px">传题选题</el-radio>
            <el-radio :label="3" style="line-height: 28px">教辅选页</el-radio>
            <el-radio :label="4" style="line-height: 28px">智能组题</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :required="true" label="纸张大小：">
          <el-select
            v-model="taskData.SizeType"
            class="select-size"
            placeholder="请选择"
            style="width: 150px"
            @change="changeSizeType"
          >
            <el-option v-if="taskData.isOnline == 3" :value="1" label="原教辅大小"></el-option>
            <el-option :value="2" label="A4"></el-option>
            <el-option :value="3" label="B5"></el-option>
            <el-option :value="4" label="自定义"></el-option>
          </el-select>
          <el-input v-if="taskData.SizeType > 1" v-model="taskData.TrueWidth" placeholder="宽" style="width: 110px">
            <i slot="suffix">毫米</i>
          </el-input>
          <el-input v-if="taskData.SizeType > 1" v-model="taskData.TrueHeight" placeholder="高" style="width: 110px">
            <i slot="suffix">毫米</i>
          </el-input>
        </el-form-item>
        <el-form-item v-if="taskData.isOnline == 1 || taskData.isOnline == 4" :required="true" label="页面边距：">
          <el-input-number
            v-model="taskData.PaddingWidth"
            :max="20"
            :min="0"
            controls-position="right"
            label="页边距"
          ></el-input-number>
          <i style="color: #c0c4cc">毫米</i>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelCreatTask">取 消</el-button>
        <el-button type="primary" @click="submitCreateTask">保存，并继续出题</el-button>
      </span>
    </el-dialog>
    <!--创建任务单窗口结束-->
  </div>
</template>

<script>
import "video.js/dist/video-js.min.css";
import "videojs-flash/dist/videojs-flash";
import videojs from "video.js";
import flvjs from "flv.js";
import QualityClass from "./detail/QualityClass";
import SharedResource from "./detail/SharedResource";
import TaskAdd from "./detail/TaskAdd";
import TaskCreate from "./detail/TaskCreate";
import TaskView from "./detail/TaskView";
import PlanClassCom from "./detail/PlanClassCom";
import EchartEvaluate from "./detail/EchartEvaluate"; //课后分析
import ExerciseAnalysis from "./detail/ExerciseAnalysis";
import TaskAnalysis from "./detail/TaskAnalysis";
import UpLoadFileStatus from "./detail/UpLoadFileStatus";
import TaskDetail from "./detail/TaskDetail";

export default {
  name: "Detail",
  components: {
    TaskDetail,
    UpLoadFileStatus,
    QualityClass,
    SharedResource,
    TaskAdd,
    TaskCreate,
    EchartEvaluate,
    TaskView,
    PlanClassCom,
    ExerciseAnalysis,
    TaskAnalysis,
  },
  data() {
    return {
      /*表单按钮控制开始*/
      controlTeachBtn: false, //添加课时
      /*表单按钮控制结束*/
      upMyQualityDialog: false,
      upMyQualityClass: null, //优师资源上传按钮.
      upMyQualityCourseName: "",
      upMyQualityE: "",
      editMyQualityDialog: false,
      editMyQualityCourseID: 0,
      editMyQualityCourseName: "",

      subjectID: 0,
      bookID: 0,
      editionID: 0,
      chapter: "", //五级下拉选择的标题.
      chapterName: "", //章节标题
      chapterID: "", //章节id. ,右侧单元里面的称之为章
      chapterLevel: 1, //选中的是章还是节：1章；2节
      teachings: [], //课时, 该章用了多少课时来讲.
      selTeaching: 0, // 当前选中的课时.
      showTeachingRange: 0,
      teachingAdd: false, // 添加新课时状态.
      teachingFormData: {
        //保存课时的表单数据 .
        ChapterID: "",
        CourseTitle: "",
        CreateDate: "",
        Knowledge: "",
        Sense: "",
        TeachingID: "",
        TeachingPlanID: 0,
        PLessonsFile: "",
        Size: "",
        Extension: "",
        FileName: "",
      }, //当前选中课时详情
      activeTab: "classFirst", //当前的标签
      /*备课开始*/
      prepareLessonsData: {
        ResourcesList: [],
        TaskListViewModelList: [],
        ClassicCourseRelTeachingPlanList: [],
      }, //备课集.
      showSharedResourceAddDialog: false, //云分享的教案资源添加窗口

      showQualityClassAddDialog: false, // 是否弹出添加优师资源窗口.
      showQualityClassVideo: false, //优师资源视频播放
      qualityClassVideo: {}, //当前选择的优师资源视频.
      taskTypes: ["在线出题", "传题选题", "教辅选页", "智能组题"],
      activeTaskIndex: 0, //当前任务单index
      taskInfo: null, //当前的任务单信息.
      showPreviewTask: false, //任务单预览窗口
      selTaskQuestions: [], //任务单的题目列表.
      showTaskAddDialog: false, // 添加任务单的窗口.

      taskData: {
        ChapterID: "", //章节id
        TeachingPlanID: "",
        TaskListID: "", //任务单的id
        TaskName: "", //任务单的名称
        isOnline: "", //区别在线出题还是图片裁题,只在添加过题目之后,存值,此后不能再改.
        Questions: [],
        IsScore: false,
        SizeType: 2,
        TrueWidth: 210,
        TrueHeight: 297,
        PaddingWidth: 10, //页边距，整型，单位毫米
      }, //编辑任务单的数据.
      showTaskCreateDialog: false, //创建任务单 对话框.
      showTaskEditDialog: false, //编辑任务单对话框
      taskPages: [], //传题选题有页的概念.
      shareDialog: false,
      shareResource: null,
      shareIndex: -1,
      sharedScope: [],
      qualityMark: 0,
      shareTaskDialog: false,
      shareTaskRescource: null,

      /*备课结束*/

      /*课中,课后,任务单分析,练习分析公共导航开始*/
      selPlanInfo: {
        selPlanIndex: 0, //当前选择的课时.
        selTaskIndex: -1, //-1代表没有用任务单或不在任务单标签.
      },
      lessonListShow: false, //根据数据加载公共导航.控制DOM
      lessonListShow2: false, //是否显示公共导航, 控制显示.
      radioArr: [], //匹配列表
      ppkc: false, //匹配课程弹框
      ppLessonId: 1, //匹配课程的id
      /*课中,课后,任务单分析,练习分析公共导航结束.*/

      /* 回顾开始*/
      lessonSrc: [], // 回顾的资源汇总.
      lessonImages: [], //回顾的图片
      lessonImgDialog: false,
      carouselIndex: 0, //显示的图片
      currentOffset: 0,
      windowSize: 3,
      paginationFactor: 330,
      players: "", //
      Cover: {
        //直播和微课的播放
        ResourcesName: "",
        ResourcesPath: "",
        show: false,
        ResourcesID: "",
      },
      managementClass: [], //每个老师所管理的班级
      issueClassValue: [], //当前发布的班级
      issueType: 1, //发布类型 . 0 全网,  // 1,校内
      issueDialog: false,
      issueResourcesId: "", //要发布的资源id.
      /* 回顾结束*/

      /*课后分析开始*/
      echartEvaluateData: [],
      echartEvaluateShow: false,
      echartEvaluateWidth: "500px", //学生评价课程宽度.
      echartEvaluateHeight: "500px", //学生评价课程宽度.
      evaluateMessage: "", //评价的内容.
      /*课后分析结束*/

      /*练习答题分析,任务答题分析公共学生表数据*/
      selLessonId: 0,
      studentList: [],
      /*练习答题分析,任务答题分析公共学生表数据*/

      /*练习题分析开始*/
      exerciseData: {
        AllSummary: [],
        AnswerGroups: [],
        QuestionImgs: [],
        SingleSummary: [],
        StudentAnswers: [],
      },
      exerciseComShow: false,
      resizeNum: 0,
      /*练习题分析结束*/

      /*任务单分析开始*/
      deviceWidth: document.documentElement.clientWidth,
      deviceHeight: document.documentElement.clientHeight,
      taskID: 0,
      taskComShow: false,
      /* task: {

       },
       taskAnalysis: {

       },
       taskStudentList: [] */
      /*任务单分析结束*/

      //上传文件时
      filesStatus: [],
      upDone: true,
      hosturl: window.hosturl,
      CancelToken: {},
      source: {},
      uploadSources: [], // 存储所有上传请求的 cancel token
    };
  },
  watch: {
    $route(to, from) {
      if (to.name == "Detail") {
        this.init();
      }
    },
    "selPlanInfo.selTaskIndex"(newIndex, oldIndex) {
      if (newIndex != -1) {
        let nowLessonClass = this.teachings[this.selTeaching].LessonList[this.selPlanInfo.selPlanIndex];
        if (nowLessonClass != null) {
          this.selLessonId = nowLessonClass.lessonID;
        }

        if (
          this.teachings != null &&
          this.teachings[this.selTeaching].TaskLists != null &&
          this.teachings[this.selTeaching].TaskLists.length > 0
        ) {
          this.taskID = this.teachings[this.selTeaching].TaskLists[newIndex].TaskRelTeachingPlanID;
        } else {
          this.taskID = 0;
        }
      }
    },
    "selPlanInfo.selPlanIndex"(newIndex, oldIndex) {
      let nowLessonClass = this.teachings[this.selTeaching].LessonList[newIndex];
      this.selLessonId = nowLessonClass.lessonID;
    },
  },
  mounted() {
    this.init();
  },
  created() {
    window.detailData = this;
  },
  methods: {
    /*初始化页面开始*/
    resetData() {
      //顶部的课时
      this.selPlanInfo = {
        selPlanIndex: 0,
        selTaskIndex: -1,
      };
      this.teachings = [];
      this.selTeaching = 0;
      this.showTeachingRange = 0;
      //回顾初始化
      this.lessonImages = [];
      this.lessonSrc = [];
      //课后分析初始
      this.echartEvaluateData = [];
      this.evaluateMessage = "";
      //练习题
      this.studentList = [];
      this.exerciseData = {
        AllSummary: [],
        AnswerGroups: [],
        QuestionImgs: [],
        SingleSummary: [],
        StudentAnswers: [],
      };
      //任务单
      this.selLessonId = 0;
      this.taskID = 0;
    },
    init() {
      this.resetData();
      this.activeTab = "classFirst";

      this.chapter =
        localStorage["v1"] +
        "/" +
        localStorage["v2"] +
        "/" +
        localStorage["v3"] +
        "/" +
        localStorage["v4"] +
        "/" +
        localStorage["v5"];
      //上传优师资源赋值/
      this.upMyQualityClass = document.getElementById("upMyQualityClass");
      this.chapterID = this.$route.query.id;
      this.chapterName = this.$route.query.name;
      this.chapterLevel = this.$route.query.chapterLevel;
      let subid = parseInt(this.$route.query.subjectID) || 0;
      let edtid = parseInt(this.$route.query.editionID) || 0;
      this.subjectID = subid;
      this.editionID = edtid;
      this.bookID = this.$route.query.bookID;
      this.getTeaching();
      this.getIssue();
      //提前获取echarts的宽度值 .
      let paneClassFirst = document.getElementById("classDetail");
      let panelWidth = getComputedStyle(paneClassFirst).width;
      //自评的值.
      this.echartEvaluateWidth = parseFloat(panelWidth) * 0.5 + "px";
      let that = this;
      window.onresize = function() {
        let paneClassFirst = document.getElementById("classDetail");
        //console.log(paneClassFirst);
        if (paneClassFirst !== null) {
          let panelWidth = getComputedStyle(paneClassFirst).width;
        }
        //自评的值.
        that.echartEvaluateWidth = parseFloat(panelWidth) * 0.5 + "px";
        that.deviceWidth = document.documentElement.clientWidth;
        that.deviceHeight = document.documentElement.clientHeight;
        that.resizeNum = Math.random();
      };
    },
    getTeaching() {
      this.axios
        .get(window.url + `GetTeachingPlanAndLessonList?chapterID=${this.chapterID}`)
        .then((res) => {
          this.teachings = res.data.data;
          //console.log(this.teachings);
          if (this.teachings.length == 0) {
            this.teachings = [];
            this.lessonListShow = false;
            this.teachingAdd = true;
            this.resetTeachingFormData();
          } else {
            this.teachings = res.data.data;
            this.lessonListShow = true;
            this.selectTeaching();
          }
        })
        .catch((error) => {
          // that.$message.error('您的网络开小差了！')
        });
    },
    /*初始化页面结束*/

    /*课时模块开始*/
    teachingMove(i) {
      //课时左右移动
      if (i > 0) {
        if (this.teachings.length - this.showTeachingRange >= 3) {
          this.showTeachingRange += 3;
        }
      } else {
        if (this.showTeachingRange >= 3) {
          this.showTeachingRange -= 3;
        }
      }
    },
    selectTeaching(i = 0) {
      //课时选中时.默认是第一个呀.
      if (i !== this.selTeaching || i == 0) {
        this.teachingAdd = false;
        this.selTeaching = i;
        this.teachingFormData = this.teachings[i];
        this.activeTab = "classFirst";
        this.selPlanInfo = {
          selPlanIndex: 0,
          selTaskIndex: -1,
        };
        //获取备课的一些信息.
        this.getBeforeClassData(this.teachingFormData.TeachingPlanID);
      }
    },
    addTeachingBtn() {
      //添加课时按钮
      this.teachingAdd = true;
      this.teachingFormData = {
        TeachingPlanID: 0,
        CourseTitle:
          this.chapterLevel == 2
            ? "【第" + (Number(this.teachings.length) + 1) + "课时】" + this.chapterName
            : this.chapterName,
        Knowledge: "",
      };
    },
    saveTeaching() {
      // 保存新课时
      const obj = this.teachingFormData;
      obj.ChapterID = this.chapterID;
      obj.SubjectID = this.subjectID;
      obj.EditionID = this.editionID;
      obj.BookID = this.bookID;
      obj.IsUnitChapter = this.chapterLevel == 1 ? 1 : 0;
      if (obj.CourseTitle.trim() == "" || obj.Knowledge.trim() == "") {
        this.$confirm("请填写完整表单!", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showCancelButton: false,
          closeOnClickModal: false,
          type: "warning",
        });
        return;
      }
      this.controlTeachBtn = true;
      let formData = new FormData();
      formData.append("text", JSON.stringify(obj));
      // console.log("------待保存的教案：", formData);
      /*
      {  
      "ChapterID": "203362",  
      "CourseTitle": "第二章 基本初等函数（1）",  
      "CreateDate": "",  
      "Knowledge": "测试",  
      "Sense": "",  
      "TeachingID": "",  
      "TeachingPlanID": 0,  
      "PLessonsFile": "/hdata/UpdateFile/1678186836912.xlsx",  
      "Size": "10.16KB",  
      "Extension": "xlsx",  
      "FileName": "实验学校六年级教师信息.xlsx",  
      "SubjectID": 0,  
      "EditionID": 0,  
      "BookID": 0,  
      "IsUnitChapter": 0,
      }
      */

      var that = this;
      this.axios
        .post(window.url + "SaveTeachingPlan", formData)
        .then((res) => {
          this.$alert(res.data.message, "提示");
          if (res.data.result == 200) {
            //添加成功,重新获取课时列表.
            this.getTeaching();
            this.controlTeachBtn = false;
            //1,添加成功后,跳转到最新课时,
            //2,添空备课的数据,
            //3,课中,分析,都要清为暂无数据的状态.
          }
        })
        .catch((error) => {
          // that.$message.error('您的网络开小差了！')
        });
    },
    delTeaching() {
      //删除课时
      this.$confirm("此操作将删除课时, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .get(window.url + `DeleteTeachingPlan?teachingPlanID=${this.teachingFormData.TeachingPlanID}`)
            .then((res) => {
              this.$alert(res.data.message, "提示");
              if (res.data.result === 200) {
                //重新查询课时列表
                this.getTeaching();
              }
            });
        })
        .catch(() => {});
    },
    resetTeachingFormData() {
      this.teachingFormData = {
        //保存课时的表单数据 .
        ChapterID: "",
        CourseTitle:
          this.chapterLevel == 2
            ? "【第" + (Number(this.teachings.length) + 1) + "课时】" + this.chapterName
            : this.chapterName,
        CreateDate: "",
        Knowledge: "",
        Sense: "",
        TeachingID: "",
        TeachingPlanID: 0,
      };
    },
    /*课时模块结束*/

    /*标签切换开始*/
    beforeTabClick(val, oldVal) {
      this.lessonListShow2 = true;
      switch (val) {
        case "classFirst":
          this.lessonListShow2 = false;
          this.echartEvaluateShow = false;
          this.exerciseComShow = false;
          this.taskComShow = false;
          return true;
        case "classIn":
          this.echartEvaluateShow = false;
          this.exerciseComShow = false;
          this.taskComShow = false;
          this.getInClassData();
          return true;
        case "classAfter":
          this.exerciseComShow = false;
          this.taskComShow = false;
          this.getAfterClass();
          this.getStudents();
          return true;
        case "classChart":
          this.echartEvaluateShow = false;
          this.exerciseComShow = true;
          this.taskComShow = false;
          this.getPracAnalysisAll();
          this.getStudents();
          return true;
        case "taskChart":
          this.exerciseComShow = false;
          if (this.selPlanInfo.selTaskIndex == -1) {
            this.selPlanInfo.selTaskIndex = 0;
          }
          this.echartEvaluateShow = false;
          this.taskComShow = true;
          return true;
      }
    },
    /*标签切换结束*/

    /*备课相关开始*/
    //上传优师资源
    // showupQualityClass(){
    //   this.upMyQualityClass.click();
    // },
    upQualityClass(e) {
      // console.log("选取的文件.", e);
      let fileName = e.target.files[0].name;
      if (fileName.substring(fileName.length - 3).toLowerCase() === "mp4") {
        this.upMyQualityE = e;
      } else {
        this.$alert("文件格式有误,优师资源只能是mp4的视频文件", "提示");
      }
      //console.log(this.upMyQualityE.target.files[0].name);
    },
    cancleUpQualityClass() {
      // 先关闭对话框
      this.upMyQualityDialog = false;
      this.sharedScope = [];
      // 使用 nextTick 确保对话框关闭后再清空数据
      this.$nextTick(() => {
        this.upMyQualityCourseName = "";
        this.upMyQualityE = "";
        if (this.$refs.upMyQualityClass) {
          this.$refs.upMyQualityClass.value = "";
        }
      });
    },
    submitUpQualityClass() {
      if (this.upMyQualityCourseName === "" || this.upMyQualityE === "") {
        this.$alert("请选择优师资源视频并输入名称.", "提示");
        return;
      }
      if (this.sharedScope.length == 0) {
        this.$alert("请选择分享范围", "提示");
        return;
      }
      let tmp = {
        // "schoolID": "dfbc645b-f117-4489-a64f-8bfd1b52b9cf",
        // "teacherID": "0bbda0c5-58c8-49b2-ab71-a152511bc9b2",
        // lessonID:this.selLessonId,
        teachingplanID: this.teachingFormData.TeachingPlanID,
        courseName: this.upMyQualityCourseName,
        chapterID: this.chapterID,
        sharedScope: this.sharedScope.join(","),
        sharedToTeacher: "",
      };
      let files = this.upMyQualityE.target.files;
      this.upDone = false;
      this.CancelToken = this.axios.CancelToken;
      // 清空之前的 cancel token 数组
      this.uploadSources = [];
      
      Array.prototype.forEach.call(files, (val) => {
        //console.log("val", val);
        this.filesStatus.push({
          fileName: val.name,
          percentage: 0,
        });
      });
      for (let i = 0, len = files.length; i < len; i++) {
        let upOk = 0;
        let file = files[i];
        let formData = new FormData();
        formData.append("text", JSON.stringify(tmp));
        formData.append("file" + i, file);
        // formData.append('TeachingPlanID', this.teachingFormData.TeachingPlanID);
        // formData.append('ChapterID', this.chapterID);
        
        // 为每个上传请求创建独立的 CancelToken
        const source = this.CancelToken.source();
        this.uploadSources.push(source);
        
        let config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            //console.log("进度:onUploadProgress"+i, progressEvent);
            // 安全地更新进度，检查 filesStatus 是否存在
            if (this.filesStatus[i]) {
              this.filesStatus[i].percentage = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
            }
          },
          cancelToken: source.token,
          timeout: 300000,
        };
        this.axios.post(window.url + "UploadMyIntensiveLectures", formData, config).then((res) => {
          // 检查上传是否已被取消（通过检查 filesStatus 是否为空）
          if (res.data.result === 200 && this.filesStatus.length > 0 && this.filesStatus[i]) {
            this.filesStatus[i].percentage = 100;
            // 先关闭对话框
            this.upMyQualityDialog = false;
            // 使用 nextTick 确保对话框关闭后再清空数据
            this.$nextTick(() => {
              this.upMyQualityCourseName = "";
              this.upMyQualityE = "";
              if (this.$refs.upMyQualityClass) {
                this.$refs.upMyQualityClass.value = "";
              }
            });
            this.init();
            this.$message.success("文件上传成功");
          } else if (res.data.result !== 200) {
            this.$alert(file.name + "上传失败,请重新上传", "提示");
          }
        }).catch((error) => {
          // 处理取消或其他错误
          if (this.axios.isCancel(error)) {
            console.log('上传已取消:', file.name);
          } else {
            console.error('上传失败:', error);
          }
        });
      }

      return;
    },
    openEditQualityDialog(scope) {
      let course = scope.row;
      // console.log(course);
      this.editMyQualityDialog = true;
      this.editMyQualityCourseID = course.ID;
      this.editMyQualityCourseName = course.CourseName;
      this.sharedScope = course.SharedScope.split(",");
      // console.log(this.sharedScope);
    },
    cancleEditQualityClass() {
      this.editMyQualityCourseID = 0;
      this.editMyQualityCourseName = "";
      this.editMyQualityDialog = false;
      this.sharedScope = [];
    },
    submitEditQualityClass() {
      if (this.editMyQualityCourseName === "") {
        this.$alert("请输入名称.", "提示");
        return;
      }
      if (this.sharedScope.length == 0) {
        this.$alert("请选择分享范围", "提示");
        return;
      }
      let tmp = {
        // "schoolID": "dfbc645b-f117-4489-a64f-8bfd1b52b9cf",
        // "teacherID": "0bbda0c5-58c8-49b2-ab71-a152511bc9b2",
        // lessonID:this.selLessonId,
        // teachingplanID: this.teachingFormData.TeachingPlanID,
        CourseName: this.editMyQualityCourseName,
        CourseId: this.editMyQualityCourseID,
        SharedScope: this.sharedScope.join(","),
        // sharedToTeacher: ''
      };
      this.axios.post(window.url + "UpdateClassicCourse", tmp).then((res) => {
        //console.log("上传返回?", res);
        if (res.data.result === 200) {
          this.editMyQualityCourseName = "";
          this.editMyQualityDialog = false;
          this.init();
          this.$message.success("修改成功.");
        } else {
          this.$message.error("修改失败,请稍后重试");
        }
      });
    },
    getBeforeClassData(teachingPlanID) {
      //根据课时获取课前相关数据.
      this.axios.get(window.url + `GetBeforeClassData?teachingPlanID=${teachingPlanID}`).then((res) => {
        this.prepareLessonsData = res.data.data; //课前所有数据.
      });
    },

    //打开分享教案/课件的对话框
    shareFile(item, index) {
      this.shareDialog = true;
      this.sharedScope = [];
      this.qualityMark = 0;
      this.shareResource = item;
      this.shareIndex = index;
    },
    //分享教案/课件确定提交
    share() {
      if (this.sharedScope.length == 0) {
        this.$alert("请选择分享范围", "提示");
        return;
      }
      this.axios
        .post(window.url + "ShareTeachingplanCourseware", {
          SharedScope: this.sharedScope.join(","),
          SharedToTeacher: "",
          QualityMark: this.qualityMark,
          ResourceID: this.shareResource.ResourcesID,
        })
        .then((res) => {
          if (res.data.result == 200) {
            this.$message.success("分享成功，感谢您的分享!");
            this.prepareLessonsData.ResourcesList[this.shareIndex].SharedScope = this.sharedScope.join(",");
            this.prepareLessonsData.ResourcesList[this.shareIndex].QualityMark = this.qualityMark;
            this.shareDialog = false;
            this.sharedScope = [];
            this.qualityMark = 0;
            this.shareResource = null;
            this.shareIndex = -1;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    //取消分享教案课件
    cancelShareFile(item, index) {
      this.$confirm("确认取消分享吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(window.url + "ShareTeachingplanCoursewareDel", {
              ResourceID: item.ResourcesID,
            })
            .then((res) => {
              if (res.data.result === 200) {
                this.$message.success("取消分享成功!");
                this.prepareLessonsData.ResourcesList[index].SharedScope = null;
                this.prepareLessonsData.ResourcesList[index].QualityMark = 0;
              } else {
                this.$message.error(res.data.message);
              }
            });
        })
        .catch(() => {});
    },

    //打开分享任务单的对话框
    openShareTaskDialog(item, index) {
      // console.log(item, index);
      this.shareTaskDialog = true;
      this.sharedScope = [];
      this.qualityMark = 0;
      this.shareTaskRescource = item;
      this.shareIndex = index;
    },
    //分享任务单确定提交
    shareTask() {
      if (this.sharedScope.length == 0) {
        this.$alert("请选择分享范围", "提示");
        return;
      }
      this.axios
        .post(window.url + "ShareTaskList", {
          SharedScope: this.sharedScope.join(","),
          SharedToTeacher: "",
          QualityMark: this.qualityMark,
          TaskListID: this.shareTaskRescource.ID ? this.shareTaskRescource.ID : this.shareTaskRescource.TaskListID,
        })
        .then((res) => {
          if (res.data.result == 200) {
            this.$message.success("分享成功，感谢您的分享!");
            // console.log("prepareLessonsData", this.prepareLessonsData);
            // console.log("shareIndex", this.shareIndex);
            this.prepareLessonsData.TaskListViewModelList[this.shareIndex].SharedScope = this.sharedScope.join(",");
            this.prepareLessonsData.TaskListViewModelList[this.shareIndex].QualityMark = this.qualityMark;
            if (this.taskInfo != null) {
              this.taskInfo.SharedScope = this.sharedScope.join(",");
              this.taskInfo.QualityMark = this.qualityMark;
            }
            // console.log(this.taskInfo);
            this.shareTaskDialog = false;
            this.sharedScope = [];
            this.qualityMark = 0;
            this.shareTaskRescource = null;
            this.shareIndex = -1;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    //取消分享教案课件
    cancelShareTask(item, index) {
      this.$confirm("确认取消分享吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(window.url + "ShareTaskListDel", {
              TaskListID: item.ID ? item.ID : item.TaskListID,
            })
            .then((res) => {
              if (res.data.result === 200) {
                this.$message.success("取消分享成功!");
                // console.log("prepareLessonsData", this.prepareLessonsData);
                // console.log("shareIndex", index);
                this.prepareLessonsData.TaskListViewModelList[index].SharedScope = null;
                this.prepareLessonsData.TaskListViewModelList[index].QualityMark = 0;
                if (this.taskInfo != null) {
                  this.taskInfo.SharedScope = null;
                  this.taskInfo.QualityMark = 0;
                }
              } else {
                this.$message.error(res.data.message);
              }
            });
        })
        .catch(() => {});
    },
    //删除备课资源
    delFile(res, i, tag) {
      console.log('删除的备课资源：',res);
      
      if (res.SharedScope && res.isCreate) {
        this.$alert("该资源您已分享出去，请先取消分享！", "警告");
        return;
      }
      //删除备课资源.
      this.$confirm("确认删除该教案课件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(window.url + "DeleteResources", {
              ResourcesID: res.ResourcesID,
              TeachingPlanID: this.teachingFormData.TeachingPlanID,
            })
            .then((res) => {
              if (res.data.result === 200) {
                this.$message.success("删除成功!");
                switch (tag) {
                  case "ResourcesList": //备课资源
                    this.prepareLessonsData.ResourcesList.splice(i, 1);
                    break;
                  case "lessonImages": //课中图片
                    this.lessonImages.splice(i, 1);
                    break;
                  default:
                    this.Cover.show = false;
                    this.getInClassData();
                    break;
                }
              } else {
                this.$message.error(res.data.message);
              }
            });
        })
        .catch(() => {});
    },

    //删除课堂回顾资源
    DeleteClassFiles(res, i, tag) {
      console.log('删除的课堂回顾资源：',res);
      let ResourcesID = res.ResourcesID;
      if (tag === 'Video') {
        if (res.State === 1 || res.isRelease) {
          this.$alert("该资源您已发布或者申请为精品课分享了出去，请先取消发布或者申请！", "警告");
          return;
        }
      }
      
      //删除课堂回顾资源.
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(window.url + "DeleteClassFiles", {
              ResourcesID: ResourcesID,
              TeachingPlanID: this.teachingFormData.TeachingPlanID,
            })
            .then((res) => {
              if (res.data.result === 200) {
                this.$message.success("删除成功!");
                switch (tag) {
                  case "ResourcesList": //备课资源
                    this.prepareLessonsData.ResourcesList.splice(i, 1);
                    break;
                  case "lessonImages": //课中图片
                    this.lessonImages.splice(i, 1);
                    break;
                  default:
                    this.Cover.show = false;
                    this.getInClassData();
                    break;
                }
              } else {
                this.$message.error(res.data.message);
              }
            });
        })
        .catch(() => {});
    },

    uploadPlanConfig(e) {
      //console.log("上传的资源:", e);
      let files = e.target.files;
      //console.log("所有文件:", files);
      if (files.length < 1) return;
      let reg = /xmind|jpg|jpeg|png|bmp|psd|gif|doc|docx|ppt|pptx|xls|xlsx|pdf/gi;
      //遍历类数组.依次,
      let isOk = true;
      Array.prototype.forEach.call(e.target.files, (val) => {
        let name = val.name;
        let nameOther = name.substring(name.lastIndexOf(".") + 1).toLowerCase();
        //console.log(nameOther+"???");
        if (!nameOther.match(reg)) {
          isOk = false;
          this.$alert(nameOther + "类型的文件不支持上传.", "提示");
        }
      });

      if (!isOk) return;
      //依次同步上传文件. 获取每个的进度.
      //第一波遍历
      this.upDone = false;
      this.CancelToken = this.axios.CancelToken;
      // 清空之前的 cancel token 数组
      this.uploadSources = [];
      
      Array.prototype.forEach.call(files, (val) => {
        //console.log("val", val);
        this.filesStatus.push({
          fileName: val.name,
          percentage: 0,
        });
      });
      //第二波同步依次遍历上传.
      for (let i = 0, len = files.length; i < len; i++) {
        let upOk = 0;
        let file = files[i];
        let formData = new FormData();
        formData.append("Files" + i, file);
        
        // 为每个上传请求创建独立的 CancelToken
        const source = this.CancelToken.source();
        this.uploadSources.push(source);
        
        let config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            //console.log("进度:onUploadProgress"+i, progressEvent);
            // 安全地更新进度，检查 filesStatus 是否存在
            if (this.filesStatus[i]) {
              this.filesStatus[i].percentage = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
            }
          },
          cancelToken: source.token,
          timeout: 300000,
        };
        this.axios.post(window.url + "UploaFileForTeachingPlan", formData, config).then((res) => {
          // this.$alert(res.data.message, "提示");
          // 检查上传是否已被取消（通过检查 filesStatus 是否为空）
          if (res.data.result === 200 && this.filesStatus.length > 0 && this.filesStatus[i]) {
            this.filesStatus[i].percentage = 100;
            this.teachingFormData.PLessonsFile = res.data.data.PLessonsFile;
            this.teachingFormData.Size = res.data.data.Size;
            this.teachingFormData.Extension = res.data.data.Extension;
            this.teachingFormData.FileName = res.data.data.FileName;
          }
        }).catch((error) => {
          // 处理取消或其他错误
          if (this.axios.isCancel(error)) {
            console.log('上传已取消:', file.name);
          } else {
            console.error('上传失败:', error);
          }
        });
      }
    },
    
    uploadConfig(e) {
      //上传备课资源.
      // console.log("上传的资源:", e);
      let files = e.target.files;
      //console.log("所有文件:", files);
      if (files.length < 1) return;
      let reg = /xmind|jpg|jpeg|png|bmp|psd|gif|doc|docx|ppt|pptx|xls|xlsx|pdf|mp4|mp3|avi|rmvb|wav|3gp|flv|rm|txt|mmap|xmmap|XMAP/gi;
      //遍历类数组.依次,
      let isOk = true;
      Array.prototype.forEach.call(e.target.files, (val) => {
        let name = val.name;
        let nameOther = name.substring(name.lastIndexOf(".") + 1).toLowerCase();
        //console.log(nameOther+"???");
        if (!nameOther.match(reg)) {
          isOk = false;
          this.$alert(nameOther + "类型的文件课件中不支持上传.", "提示");
        }
      });
      if (!isOk) return;
      //依次同步上传文件. 获取每个的进度.
      //第一波遍历
      this.upDone = false;
      this.CancelToken = this.axios.CancelToken;
      // 清空之前的 cancel token 数组
      this.uploadSources = [];

      Array.prototype.forEach.call(files, (val) => {
        //console.log("val", val);
        this.filesStatus.push({
          fileName: val.name,
          percentage: 0,
        });
      });
      //第二波同步依次遍历上传.
      for (let i = 0, len = files.length; i < len; i++) {
        let upOk = 0;

        let file = files[i];
        let formData = new FormData();
        formData.append("file" + i, file);
        formData.append("TeachingPlanID", this.teachingFormData.TeachingPlanID);
        formData.append("ChapterID", this.chapterID);
        
        // 为每个上传请求创建独立的 CancelToken
        const source = this.CancelToken.source();
        this.uploadSources.push(source);
        
        let config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            //console.log("进度:onUploadProgress"+i, progressEvent);
            // 安全地更新进度，检查 filesStatus 是否存在
            if (this.filesStatus[i]) {
              this.filesStatus[i].percentage = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
            }
          },
          cancelToken: source.token,
          timeout: 300000,
        };
        this.axios.post(window.url + "UploadResources", formData, config).then((res) => {
          // this.$alert(res.data.message, "提示");
          // 检查上传是否已被取消（通过检查 filesStatus 是否为空）
          if (res.data.result === 200 && this.filesStatus.length > 0 && this.filesStatus[i]) {
            this.filesStatus[i].percentage = 100;
            res.data.data.list.forEach((item, index) => {
              item.isCreate = 1;
              this.prepareLessonsData.ResourcesList.push(item);
            });
          }
        }).catch((error) => {
          // 处理取消或其他错误
          if (this.axios.isCancel(error)) {
            console.log('上传已取消:', file.name);
          } else {
            console.error('上传失败:', error);
          }
        });
      }
    },
    checkTeachingPlanID() {
      if (this.teachingFormData.TeachingPlanID === 0) {
        this.$message.error("您还没有创建课时.");
        return false;
      }
      return true;
    },
    upFileClose(e) {
      // console.log("关闭上传文件:", e);
      // 先关闭对话框
      this.upDone = true;
      // 使用 nextTick 确保对话框关闭后再清空数据
      this.$nextTick(() => {
        this.filesStatus = [];
        this.uploadSources = []; // 清空 cancel token 数组
        // 安全地清空文件输入框
        if (this.$refs.upMyQualityClass) {
          this.$refs.upMyQualityClass.value = "";
        }
        if (this.$refs.upChapterFile) {
          this.$refs.upChapterFile.value = "";
        }
      });
    },
    upFileCancel(e) {
      // 取消所有正在进行的上传请求
      if (this.uploadSources && this.uploadSources.length > 0) {
        this.uploadSources.forEach((source) => {
          source.cancel("用户取消了上传操作");
        });
        this.uploadSources = [];
      }
      this.upFileClose();
    },

    //删除优师资源
    deleteClassicCourseTeachingPlan(scope) {
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            TeachingPlanID: this.teachingFormData.TeachingPlanID, //备课信息id、
            ClassicCourseID: scope.row.ID, //优师资源id、
          };
          this.axios
            .post(window.url + "DeleteClassicCourseTeachingPlan ", params)
            .then((res) => {
              if (res.data.result === 200) {
                this.$message({
                  showClose: true,
                  message: "删除成功",
                  type: "success",
                });
                this.getBeforeClassData(this.teachingFormData.TeachingPlanID);
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              this.$message({
                showClose: true,
                message: error,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    //点击优师资源名称,则打开视频播放.
    cellClick(row, column) {
      if (column.property == "CourseName") {
        this.showQualityClassVideo = true;
        this.qualityClassVideo = row;
      }
    },
    // 关闭视频播放
    closeQualityClassVideo() {
      this.showQualityClassVideo = false;
      this.qualityClassVideo = {};
    },
    //删除任务单
    deleteTaskListTeachingPlan(task) {
      console.log('要删除的任务单：',task);
      
      if (task.SharedScope && task.IsCreate) {
        this.$alert("该资源您已分享出去，请先取消分享！", "警告");
        return;
      }
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //关闭任务单预览页面
          this.showPreviewTask = false;
          this.axios
            .post(window.url + "DeleteTaskListTeachingPlan", {
              TeachingPlanID: this.teachingFormData.TeachingPlanID,
              TaskListID: task.ID ? task.ID : task.TaskListID,
            })
            .then((res) => {
              if (res.data.result == 200) {
                this.$message({
                  showClose: true,
                  message: "任务单删除成功",
                  type: "success",
                });
                this.getTeaching();
                this.getBeforeClassData(this.teachingFormData.TeachingPlanID);
              } else {
                //异常
                this.$message({
                  showClose: true,
                  message: res.data.message,
                  type: "error",
                });
              }
            })
            .catch((error) => {
              //异常
              this.$message({
                showClose: true,
                message: error,
                type: "warning",
              });
            });
        })
        .catch(() => {});
    },
    //编辑任务单
    editTaskList(task) {
      let isOnline = task.isOnline ? task.isOnline : task.Online;
      this.editTaskID = task.ID ? task.ID : task.TaskListID;
      this.editTaskType = isOnline;
      this.showPreviewTask = false;
      // console.log(task);
      /* if (isOnline === 1) {
        this.axios
          .post(window.url + "GetTaskListAndQuestionList", {
            TaskListID: task.ID ? task.ID : task.TaskListID,
            TeachingPlanID: this.teachingFormData.TeachingPlanID,
          })
          .then((res) => {
            //异常处理.
            if (res.data.result !== 200) {
              this.$message({
                message: res.data.message,
                type: "error",
              });
              return;
            }
            //获取正常数据.
            this.taskData = res.data.data;
            this.showTaskEditDialog = true;
            if (this.taskData.SizeType == 0) {
              this.taskData.SizeType == 2;
              this.taskData.TrueWidth = 210;
              this.taskData.TrueHeight = 297;
            }
            if (this.taskData.isOnline == 1 || this.taskData.isOnline == 4) {
              //在线出题,智能组卷
              if (!this.taskData.PaddingWidth || this.taskData.PaddingWidth == 0) {
                this.taskData.PaddingWidth = 10;
              }
            } else {
              this.taskData.PaddingWidth = 0;
            }
          });
      } else if (isOnline === 2 || isOnline === 3) {
        this.axios({
          method: "GET",
          url: window.url + "GetJiaoFuZiLiaoForEdit2",
          params: {
            TaskListID: task.ID ? task.ID : task.TaskListID,
            TeachingPlanID: this.teachingFormData.TeachingPlanID,
          },
        }).then((res) => {
          //异常处理.
          //console.log("教辅资料2",res);
          if (res.data.result !== 200) {
            this.$message({
              message: res.data.message,
              type: "error",
            });
            return;
          }
          //获取正常数据.
          let resData = res.data.data;
          this.taskData = resData["taskList"];
          //把所有页的题目组合到一个数组中,并按题号排序
          if (!this.taskData.Questions) {
            this.taskData.Questions = [];
          }
          //组合题目.
          this.taskPages = resData["taskPagesAndQuestions"];
          this.taskPages.forEach((item) => {
            let ql = item.Questions;
            if (ql.length > 0) {
              this.taskData.Questions = this.taskData.Questions.concat(ql);
            }
          });
          this.taskData.Questions.sort((a, b) => {
            return a.sort - b.sort;
          });
          if (this.taskData.SizeType == 0) {
            this.taskData.SizeType == 2;
            this.taskData.TrueWidth = 210;
            this.taskData.TrueHeight = 297;
          }
          if (this.taskData.isOnline == 1 || this.taskData.isOnline == 4) {
            //在线出题,智能组卷
            if (!this.taskData.PaddingWidth || this.taskData.PaddingWidth == 0) {
              this.taskData.PaddingWidth = 10;
            }
          } else {
            this.taskData.PaddingWidth = 0;
          }
          this.showTaskEditDialog = true;
        });
      } else  */if (isOnline === 4) {
        //组卷出题，跳转到组卷页面
        let baseUrl;
        let localHref = location.href.indexOf("localhost");
        if (localHref < 0) {
          if (window.url.indexOf("test") > -1) {
            baseUrl = "https://hwtest.jianxiangjiaoyu.com";
          } else {
            baseUrl = "https://hw.jianxiangjiaoyu.com";
          }
        } else {
          baseUrl = "http://localhost:8849";
        }
        let redirect = "/paper?paperId=" + task.PaperID;
        let url = `${baseUrl}#/aLogin?un=${sessionStorage["un"]}&md5=${sessionStorage["Md5"]}&redirect=${redirect}`;
        window.open(url, "_bank");
      } else {
        this.showTaskEditDialog = true;
      }
    },
    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;
    },
    previewTask(row, column) {
      let taskList = this.prepareLessonsData.TaskListViewModelList;
      // console.log("taskList", taskList);
      // console.log("row", row);
      let taskRelTeachingPlanID = row.TaskRelTeachingPlanID;
      for (let i = 0; i < taskList.length; i++) {
        let task = taskList[i];
        if (task.ID == row.ID) {
          this.activeTaskIndex = i;
          break;
        }
      }
      this.taskInfo = row;
      if (column.property == "TaskName") {
        this.axios
          .get(window.url + "GetTaskListPageQuesiton?TaskRelTeachingPlanID=" + taskRelTeachingPlanID)
          .then((res) => {
            let result = res.data;
            if (result.result === 200) {
              let taskData = result.data;
              this.taskInfo = taskData;
              this.taskInfo.isOnline = taskData.Online;
              this.selTaskQuestions = [];
              if (this.taskInfo.SizeType == 0) {
                this.taskInfo.SizeType == 2;
                this.taskInfo.TrueWidth = 210;
                this.taskInfo.TrueHeight = 297;
              }
              if (this.taskInfo.isOnline == 1 || this.taskInfo.isOnline == 4) {
                //在线出题,智能组卷
                if (!this.taskInfo.PaddingWidth || this.taskInfo.PaddingWidth == 0) {
                  this.taskInfo.PaddingWidth = 10;
                }
              } else {
                this.taskInfo.PaddingWidth = 0;
              }

              this.pageCount = this.taskInfo.pages.length;
              this.pageNum = 1;
              for (let taskPage of this.taskInfo.pages) {
                this.selTaskQuestions = this.selTaskQuestions.concat(taskPage.questions);
              }
              this.activeIndex = 0;
              this.activeQuestion = this.selTaskQuestions[0];
              this.showPreviewTask = true;
            }
          })
          .catch((error) => {
            this.$message.error("您的网络开小差了！");
          });
      }
    },
    // 预览任务单
    /* previewTaskQuestion(row, column) {
      let taskList = this.prepareLessonsData.TaskListViewModelList;
      let taskRelTeachingPlanID = row.TaskRelTeachingPlanID;
      for (let i = 0; i < taskList.length; i++) {
        let task = taskList[i];
        if (task.ID == row.ID) {
          this.activeTaskIndex = i;
          break;
        }
      }
      this.taskInfo = row;
      if (column.property == "TaskName") {
        if (this.taskInfo.isOnline == 4) {
          this.axios
            .get(window.url + "GetTaskListPageQuesiton?TaskRelTeachingPlanID=" + taskRelTeachingPlanID)
            .then((res) => {
              var result = res.data;
              this.returnCode(result.result, result.message);
              if (200 == result.result) {
                //正常数据
                let taskData = result.data;
                this.taskInfo = taskData;
                this.selTaskQuestions = [];
                for (let taskPage of taskData.pages) {
                  this.selTaskQuestions = this.selTaskQuestions.concat(taskPage.questions);
                }
                this.showPreviewTask = true;
              }
            });
        } else {
          this.axios
            .post(window.url + "GetTaskForQuestionList", {
              TaskListID: row.ID,
            })
            .then((res) => {
              //异常处理.
              if (res.data.result !== 200) {
                this.$message.error({
                  message: res.data.message,
                });
                return;
              }
              //获取正常数据.
              this.selTaskQuestions = res.data.data;
              this.showPreviewTask = true;
            });
        }
      }
    }, */
    //创建任务单
    TaskCreateDialog() {
      this.resetTaskData();
      this.showTaskCreateDialog = true;
    },

    cancelCreatTask() {
      this.resetTaskData();
      this.showTaskCreateDialog = false;
    },

    changeQuestionType(e) {
      if (this.taskData.isOnline == 1 || this.taskData.isOnline == 4) {
        this.taskData.PaddingWidth = 10;
      } else {
        this.taskData.PaddingWidth = 0;
      }
      if (this.taskData.isOnline != 3 && this.taskData.SizeType == 1) {
        this.taskData.SizeType = 2;
        this.taskData.TrueWidth = 210;
        this.taskData.TrueHeight = 297;
      }
			if (this.taskData.isOnline == 3 && this.taskData.isOnline == 0) {
			  this.taskData.SizeType = 1;
			  this.taskData.TrueWidth = 0;
			  this.taskData.TrueHeight = 0;
			}
    },

    changeSizeType() {
      switch (this.taskData.SizeType) {
        case 1:
          this.taskData.TrueWidth = 0;
          this.taskData.TrueHeight = 0;
          break;
        case 2:
          this.taskData.TrueWidth = 210;
          this.taskData.TrueHeight = 297;
          break;
        case 3:
          this.taskData.TrueWidth = 176;
          this.taskData.TrueHeight = 250;
          break;
        case 4:
          if (this.taskData.TrueWidth == 0) {
            this.taskData.TrueWidth = 210;
            this.taskData.TrueHeight = 297;
          }
          break;
        default:
          this.taskData.TrueWidth = 210;
          this.taskData.TrueHeight = 297;
          break;
      }
    },

    submitCreateTask() {
      //任务单名称检测
      if (this.taskData.TaskName === "") {
        this.$alert(`名称未填写`, "提示");
        return;
      }
      if (this.taskData.isOnline == 0) {
        this.$alert(`请选择出题方式`, "提示");
        return;
      }
      if (
        this.taskData.SizeType > 1 &&
        (this.taskData.TrueWidth == 0 ||
          this.taskData.TrueHeight == 0 ||
          this.taskData.TrueWidth == "" ||
          this.taskData.TrueHeight == "")
      ) {
        this.$alert(`请选择纸张大小`, "提示");
        return;
      }
      //保存数据
      let tmp = {
        TaskName: this.taskData.TaskName,
        ChapterID: this.taskData.ChapterID,
        TaskListID: this.taskData.TaskListID,
        TeachingPlanID: this.taskData.TeachingPlanID,
        isOnline: this.taskData.isOnline,
        IsScore: this.taskData.IsScore,
        SizeType: this.taskData.SizeType,
        TrueWidth: this.taskData.TrueWidth,
        TrueHeight: this.taskData.TrueHeight,
        PaddingWidth: this.taskData.PaddingWidth,
      };
      /*tmp.IsScore = tmp.IsScore ? 1 : 0;
       tmp.isOnline = isOnline; //是不是在线出题.*/
      this.axios.post(window.url + "SaveQuestionStem ", tmp).then((res) => {
        //console.log("保存/更新任务单:", res);
        //异常处理.
        if (res.data.result !== 200) {
          this.$message({
            message: res.data.message,
            type: "error",
          });
          return;
        }
        //获取正常数据.
        let ID = res.data.data;

        this.$message.success(`保存成功`);

        if (this.taskData.isOnline == 4) {
          this.taskData.PaperID = ID;
          //组卷出题，跳转到组卷页面
          let baseUrl;
          let localHref = location.href.indexOf("localhost");
          if (localHref < 0) {
            if (window.url.indexOf("test") > -1) {
              baseUrl = "https://hwtest.jianxiangjiaoyu.com";
            } else {
              baseUrl = "https://hw.jianxiangjiaoyu.com";
            }
          } else {
            baseUrl = "http://localhost:8849";
          }
          let redirect = "/paper?paperId=" + this.taskData.PaperID;
          let url = `${baseUrl}#/aLogin?un=${sessionStorage["un"]}&md5=${sessionStorage["Md5"]}&redirect=${redirect}`;
          window.open(url, "_bank");
          this.getTeaching();
          this.getBeforeClassData(this.teachingFormData.TeachingPlanID);
          this.resetTaskData();
        } else {
          this.editTaskID = ID;
          this.editTaskType = this.taskData.isOnline;
          this.taskData.TaskListID = ID;
          this.taskData.Questions = [];
          this.taskPages = [];
          this.showTaskEditDialog = true;
          this.getTeaching();
          this.getBeforeClassData(this.teachingFormData.TeachingPlanID);
        }
        this.showTaskCreateDialog = false;
      });
    },

    // 重置任务单
    resetTaskData() {
      //在线出题+
      this.taskData = {
        ChapterID: this.chapterID, //章节C
        TeachingPlanID: this.teachingFormData.TeachingPlanID,
        TaskListID: "", //任务单的id
        TaskName: "", //任务单的名称
        isOnline: "", //区别在线出题还是图片裁题,只在添加过题目之后,存值,此后不能再改.
        Questions: [], //在线出题
        IsScore: false, //是否积分制.
        SizeType: 2,
        TrueWidth: 210,
        TrueHeight: 297,
        PaddingWidth: 10, //页边距，整型，单位毫米
      };
      //分页.
      this.taskPages = [];
    },
    // 任务单窗口关闭之前,检测传题选题是有页空题情况.
    closeBefore(done) {
      //传题选题才会检测
      /* if (this.taskData.isOnline === 2) {
       for (let tmp of this.taskPages) {

       if (tmp.Questions.length <= 0) {
       this.$alert("您有未截题目的页,请截题或删除该页", "提示");
       return;
       }
       }
       done();
       } */
      done();
    },

    // 任务单窗口关闭
    closeTaskDialog() {
      // console.log("任务单窗口关闭");
      this.getTeaching();
      this.getBeforeClassData(this.teachingFormData.TeachingPlanID);
      this.resetTaskData(); //还原任务单数据.
    },

    closeTaskAddDialog() {
      // console.log("添加云任务单窗口关闭");
      this.getTeaching();
      this.getBeforeClassData(this.teachingFormData.TeachingPlanID);
    },
    /*备课相关结束*/

    /*课中,课后,练习题分析,任务单分析的公共导航开始*/
    // 获取列表进行匹配.
    ppClassList() {
      this.axios.post(window.url + "MatchingPlanClass", {}).then((res) => {
        if (res.data.data.length === 0) {
          this.$alert("暂无可匹配的资源", "提示");
          return;
        }
        this.ppkc = true;
        this.radioArr = res.data.data;
      });
    },
    // 匹配
    ppClick() {
      let that = this;
      that.ppkc = false;
      this.axios
        .post(window.url + "Matching", {
          PlanClassID: that.ppLessonId,
          TeachingPlanID: that.teachingFormData.TeachingPlanID,
        })
        .then((res) => {
          if (res.data.result !== 200) {
            this.$alert(res.data.message, "提示");
            return;
          }
          //匹配成功后, 获取最新的课时列表, 同时选中最后一个, 同时获取最后一个的数据.
          this.axios.get(window.url + `GetTeachingPlanAndLessonList?chapterID=${this.chapterID}`).then((res2) => {
            if (res2.data.result !== 200) {
              this.$alert(res2.data.message, "提示");
              return;
            }
            this.teachings = res2.data.data;
          });
        });
    },
    //取消匹配
    cancelMatch(i) {
      // console.log("cancel-match", i);
      this.selPlanInfo.selPlanIndex = i;
      let teachingLesson = this.teachings[this.selTeaching].LessonList[i];
      let that = this;
      this.$confirm("确认取消匹配该资源吗？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(window.url + "UnmatchClass", {
              planClassId: teachingLesson.PlanClassID,
            })
            .then((res) => {
              var data = res.data;
              // console.log(data);
              if (data.result == 200) {
                this.$message.success("取消成功！");
                // console.log(this.teachings[this.selTeaching].LessonList);
                this.teachings[this.selTeaching].LessonList.splice(i, 1);
                // console.log(this.teachings[this.selTeaching].LessonList);
              }
            })
            .catch((error) => {
              // that.$message.error('您的网络开小差了！')
            });
        })
        .catch(() => {});
    },
    //选中上课的班级.
    clickPlanLi(i) {
      let teachingLesson = this.teachings[this.selTeaching].LessonList[this.selPlanInfo.selPlanIndex];
      switch (this.activeTab) {
        case "classFirst":
          break;
        case "classIn":
          this.getImageListByLessonID(teachingLesson.lessonID);
          break;
        case "classAfter":
          this.getAfterClass();
          this.getStudents();
          break;
        case "classChart":
          this.getPracAnalysisAll();
          this.getStudents();
          break;
        case "taskChart":
          break;
      }
      /////检查当前是不是任务单
      if (this.activeTab !== "taskChart") {
      }
    },
    clickTaskLi(i) {},
    /*课中,课后,练习题分析,任务单分析的公共导航结束.*/

    /*回顾开始*/
    moveCarousel(direction) {
      // 课中图片移动.
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor;
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor;
      }
    },
    getImageListByLessonID(lessonID) {
      //获取回顾的图片
      this.axios.get(window.url + `GetImageListByLessonID?lessonID=${lessonID}`).then((res) => {
        if (res.data.result !== 200) {
          this.$alert(res.data.message, "提示");
          return;
        }
        this.lessonImages = res.data.data;
      });
    },
    //图片弹出展示
    imgPopShow(i) {
      this.carouselIndex = i;
      this.lessonImgDialog = true;
    },

    //获取回顾的数据.
    getInClassData() {
      //console.log("课时数据.", this.teachings, "选中的课时数据.", this.selTeaching);
      // console.log("上课班级信息", this.teachings[this.selTeaching].LessonList);
      // console.log("上课任务单信息", this.teachings[this.selTeaching].TaskLists);
      // console.log("当前选择的班级和任务单.",this.selPlanInfo);
      // console.log("当前堂信息.",this.teachings[this.selTeaching].LessonList[this.selPlanInfo.selPlanIndex]);
      // console.log("当前堂中任务单信息..",this.teachings[this.selTeaching].TaskLists[this.selPlanInfo.selPlanIndex]);
      let nowLessonClass = this.teachings[this.selTeaching].LessonList[this.selPlanInfo.selPlanIndex];
      if (nowLessonClass) {
        this.axios
          .get(
            window.url +
              `GetInClassData?teachingPlanID=${nowLessonClass.TeachingPlanID}&lessonID=${nowLessonClass.lessonID}`
          )
          .then((res) => {
            //console.log("回顾数据:",res);
            if (res.data.result !== 200) {
              this.$alert(res.data.message, "提示");
              return;
            }
            this.lessonSrc = res.data.data;
            this.lessonImages = this.lessonSrc.ImageList;
          });
      }
    },
    videoPlay(row, column) {
      if (column.property == "ResourcesName") {
        // console.log(row.ResourcesPath,row.ResourcesPath.substring(row.ResourcesPath.length-3));
        this.Cover = {
          ResourcesName: row.ResourcesName,
          ResourcesPath: row.ResourcesPath,
          ResourcesID: row.ResourcesID,
          show: true,
        };
        // if(row.ResourcesPath.substring(row.ResourcesPath.length-3)==='3u8'){
        //   this.Cover = {
        //     ResourcesName: row.ResourcesName,
        //     ResourcesPath: row.ResourcesPath,
        //     ResourcesID: row.ResourcesID,
        //     show: true,
        //   };
        // }else {
        //
        // }
        // console.log(this.Cover);
        this.$nextTick().then((res) => {
          if (this.Cover.ResourcesPath.substring(this.Cover.ResourcesPath.length - 3) == "flv") {
            this.Cover.Type = "flv";
            if (flvjs.isSupported()) {
              this.players = document.getElementById("videoCover" + this.Cover.ResourcesID);
              let url = this.Cover.ResourcesPath;
              //console.log(url);
              let flvPlayer = flvjs.createPlayer({
                type: "flv",
                url: url,
              });
              flvPlayer.attachMediaElement(this.players);
              flvPlayer.load();
              flvPlayer.play();
            }
          } else {
            this.Cover.Type = "mp4";
            this.players = videojs("videoCover" + this.Cover.ResourcesID, {}, function() {
              this.play();
            });
          }
        });
      }
    },
    closeVideo(co) {
      if (co.Type === "mp4") {
        this.players.dispose();
      } else {
        this.players = null;
      }
      this.Cover = {
        ResourcesName: "",
        ResourcesPath: "",
        ResourcesID: "",
        show: false,
      };
    },
    //获取发布相关数据.--放到初始化即可.
    getIssue() {
      this.axios.post(window.url + "AdminClass ", {}).then((res) => {
        this.managementClass = res.data.data;
      });
    },
    //微课/直播发布.开关.
    issueOnOff(scope) {
      //获取当前发布的班级信息.
      this.issueClassValue = [];
      this.issueResourcesId = scope.row.ResourcesID;
      this.axios({
        method: "GET",
        url: window.url + "GetBindingTypePrivilege",
        params: {
          ResourcesId: this.issueResourcesId,
        },
      }).then((res) => {
        // this.issueType = res.data.data.Type;
        res.data.data.PrivilegeList.forEach((item, index) => {
          this.issueClassValue.push(item.GradeId);
        });
        this.issueDialog = true;
      });
    },
    //取消发布
    cancleIssue(scope) {
      // console.log("取消发布",scope);
      this.$confirm("确认取消发布吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ResourcesId = scope.row.ResourcesID;
          this.axios({
            method: "post",
            url: window.url + "DeleteBindingPrivilege",
            data: {
              ResourcesId,
            },
          }).then((res) => {
            //console.log("取消发布:",res);
            if (res.data.result !== 200) {
              this.$message.error(res.data.message);
              return;
            }
            this.getInClassData();
            this.$message.success('取消发布成功');
          });
        })
        .catch(() => {});
    },
    //发布确定按钮.
    issue() {
      this.axios
        .post(window.url + "PrivilegeBinding ", {
          GradeId: this.issueClassValue,
          ResourcesId: this.issueResourcesId,
          Type: this.issueType,
        })
        .then((res) => {
          if (res.data.result !== 200) {
            this.$alert(res.data.message, "提示");
            return;
          }
          this.$message({
            message: '发布成功',
            type: 'success'
          });
          this.issueDialog = false;
          this.getInClassData();
        });
    },
    // 微课申请精品课
    ApplyClassicCourse(scope) {
      this.$confirm("申请精品后，将会在平台内分享推荐，他人可以观看学习使用您的课程文件，是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //console.log("精品课",scope,scope.row.ResourcesID);
          this.axios
            .post(window.url + "ApplyClassicCourse", {
              ResouresID: scope.row.ResourcesID || scope.row.ResouresID,
            })
            .then((res) => {
              //异常处理.
              if (res.data.result !== 200) {
                this.$alert(res.data.message, "提示");
                return;
              }
              this.$message({
                message: '申请成功',
                type: 'success'
              });
              this.getInClassData();
              //this.init();
            });
        })
        .catch(() => {});
    },
    ApplyClassicCourse2(scope) {
      this.$confirm("您申请精品后，将会在平台内分享推荐，他人可以观看学习使用您的课程文件,是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(window.url + "ApplyClassicCourse", {
              ResouresID: scope.row.ResouresID,
            })
            .then((res) => {
              //异常处理.
              if (res.data.result !== 200) {
                this.$alert(res.data.message, "提示");
                return;
              }
              this.$message.success('精品课申请成功');
              this.init();
            });
        })
        .catch(() => {});
    },
    // 任务单申请精品
    taskApplyQuality(scope) {
      this.$confirm("申请精品后，将会在平台内分享推荐，他人可以观看学习使用您的任务单,是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // console.log(scope);
          // return;
          this.axios
            .post(window.url + "ApplyTaskList", {
              TaskListID: scope.row.ID,
            })
            .then((res) => {
              if (res.data.result !== 200) {
                this.$alert(res.data.message, "提示");
                return;
              }
              this.$message.success('任务单申请成功');
              
              this.getInClassData();
              // this.init();
            });
        })
        .catch(() => {});
    },
    //取消任务单精品
    CancelBoutique(scope) {
      //console.log(scope);
      this.$confirm("取消精品后, 他人无法再用任务单,是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(window.url + "CancelBoutique ", {
              taskListID: scope.row.ID,
            })
            .then((res) => {
              //console.log("res", res);
              if (res.data.result !== 200) {
                this.$alert(res.data.message, "提示");
                return;
              }
              
              this.$message.success('取消申请成功');
              this.getInClassData();
              // this.init();
            });
        })
        .catch(() => {});
    },
    //取消微课精品,
    CancelBoutique2(scope) {
      //console.log(scope);
      this.$confirm("取消精品后, 他人无法再用微课,是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(window.url + "CancelWeike ", {
              resouceId: scope.row.ResourcesID,
            })
            .then((res) => {
              //console.log("res", res);
              if (res.data.result !== 200) {
                this.$alert(res.data.message, "提示");
                return;
              }
              this.$message.success('取消精品成功');
              this.$message({
                message: '取消精品成功',
                type: 'success'
              });
              this.getInClassData();
              // this.init();
            });
        })
        .catch(() => {});
    },
    /*回顾结束*/

    /*课后分析开始*/
    //获取学生对课程评价.
    getAfterClass() {
      let nowLessonClass = this.teachings[this.selTeaching].LessonList[this.selPlanInfo.selPlanIndex];
      //console.log("呵呵",nowLessonClass);
      let queryStr = `?teachingPlanID=${nowLessonClass.TeachingPlanID}&lessonID=${
        nowLessonClass.lessonID
      }&planclassID=${nowLessonClass.PlanClassID}`;
      if (nowLessonClass) {
        this.axios.get(window.url + `GetAfterClassData${queryStr}`).then((res) => {
          this.echartEvaluateData = res.data.data.StudentMateria;
          this.evaluateMessage = res.data.data.TeacherMateria || "";
          this.echartEvaluateShow = true;
        });
      }
    },
    evaluateSave() {
      let obj = {};
      Object.assign(obj, this.teachings[this.selTeaching].LessonList[this.selPlanInfo.selPlanIndex]);
      obj.sense = this.evaluateMessage;
      obj.planClassID = obj.PlanClassID;
      if (obj.sense === "") {
        this.$confirm("请填写完整表单!", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showCancelButton: false,
          closeOnClickModal: false,
          type: "warning",
        });
        return;
      }
      this.axios
        .post(window.url + "SaveTeacherSense", obj)
        .then((res) => {
          var data = res.data;
          this.$confirm(data.message, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            showCancelButton: false,
            type: "success",
          })
            .then(() => {})
            .catch(() => {});
        })
        .catch((error) => {
          // that.$message.error('您的网络开小差了！')
        });
    },
    /*课后分析结束*/

    /*练习题分析,任务单分析, 获取学生名单*/
    getStudents() {
      let nowLessonClass = this.teachings[this.selTeaching].LessonList[this.selPlanInfo.selPlanIndex];
      if (nowLessonClass) {
        this.selLessonId = nowLessonClass.lessonID;
        this.axios
          .post(window.url + "GetStudents  ", {
            lessonID: this.selLessonId,
            sort: 2,
          })
          .then((res) => {
            //console.log("哈哈哈", res);
            this.studentList = res.data.data;
            // var data = res.data;
            // that.returnCode(data.result, data.message);
            // that.tableData = data.data.slice(0, 6);
          });
      }
    },
    /*练习题分析,任务单分析, 获取学生名单*/

    /* 练习题分析开始*/
    getPracAnalysisAll() {
      let nowLessonClass = this.teachings[this.selTeaching].LessonList[this.selPlanInfo.selPlanIndex];
      if (nowLessonClass) {
        this.axios.get(window.url + `GetPracAnalysisAll?lessionId=${nowLessonClass.lessonID}`).then((res) => {
          this.exerciseData = res.data.data;

          for (let tmp in this.exerciseData) {
            // console.log(this.exerciseData[tmp]);
            if (!this.exerciseData[tmp]) {
              this.exerciseData[tmp] = [];
            }
          }
          //console.log("新:练习题分析:", this.exerciseData);
        });
      }
    },
    /* 练习题分析结束*/

    /*任务单分析开始*/

    /*任务单分析结束*/
    // 返回值调用
    returnCode(code, msg) {
      var that = this;
      if (code != 200) {
        if (code == 201) {
          this.$router.push({
            name: "Login",
          });
        }
        that.$message.error(msg);
      }
    },
    resourceCellClick(row, column) {
      if (column.property == "ResourcesName") {
        window.open(row.ResourcesPath, "blank");
      }
    },
    downFile(url, name) {
      let index = url.lastIndexOf("/");
      //console.log(url,index,url.substring(index+1));
      //let name=url.substring(index+1);
      const downloadRes = async () => {
        let response = await fetch(url); // 内容转变成blob地址
        let blob = await response.blob(); // 创建隐藏的可下载链接
        let objectUrl = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = objectUrl;
        a.download = name;
        a.click();
        a.remove();
      };
      downloadRes();
    },
  },
  filters: {
    formatState(val, arg) {
      switch (val) {
        case 0:
          return "待审核";
        case 1:
          return "审核成功";
        case 2:
          return "审核失败";
      }
    },
    formatSelection(val, arg) {
      switch (val) {
        case "A":
          return "A,完全掌握";
        case "B":
          return "B,基本掌握";
        case "C":
          return "C,疑问较多";
        case "D":
          return "D,未曾掌握";
        default:
          return val;
      }
    },
  },
  computed: {
    atEndOfList() {
      return this.currentOffset <= this.paginationFactor * -1 * (this.lessonImages.length - this.windowSize);
    },
    atHeadOfList() {
      return this.currentOffset === 0;
    },
  },
};
</script>
<style lang="less" scoped>
.Detail {
  /deep/ .el-dialog {
    /* margin-top: 7vh !important;
    width: 60%; 
    .el-dialog__body {
      padding: 0;
    }*/
  }
  /*height: 100%;*/
  margin-bottom: 20px;

  .submitBox {
    text-align: left;
    margin-bottom: 10px;

    .submit {
      width: 140px;
      height: 40px;
      cursor: pointer;
      margin-top: 20px;
      text-align: center;
      background-color: #1e87f0;
      color: #ffffff;
      display: inline-block;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      border-radius: 3px;
    }

    .submit:nth-child(2) {
      margin-left: 30px;
    }

    .controlTeachBtn {
      background: #ddd;
    }
  }

  .TopBox {
    display: inline;
    white-space: nowrap;
    /*规定段落中的文本不进行换行*/
    overflow-x: auto;
    /*水平方向，超出部分添加滚动机制*/
    float: right;
    /*一定要设置左侧浮动*/
    overflow-y: hidden;
    /*竖直方向，超出部分隐藏*/
    position: relative;
    padding: 0 30px;
    font-size: 14px;
    font-weight: 500;
    height: 32px;
    line-height: 32px;
    margin-top: 6px;
    transition: all linear 0.3s;

    .icon {
      font-size: 18px;
      line-height: 32px;
      cursor: pointer;
    }

    .icon-xiangzuola {
      position: absolute;
      top: 0;
      left: 0;
      display: inline-block;
      height: 32px;
      width: 32px;
    }

    .icon-youla {
      position: absolute;
      top: 0;
      right: 0;
      display: inline-block;
      height: 32px;
      width: 32px;
    }

    .TopBtn {
      padding: 0 1px;
      display: inline-block;
      /*border: 1px solid #dedede;*/
      /*margin-top: 8px;*/
      height: 32px;
      line-height: 32px;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      border-radius: 3px;
      cursor: pointer;
      text-align: center;
      margin-right: 1%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .TopBtnCover {
      /*color: #ffffff;*/
      /*background-color: #1E87F0;*/
      font-weight: 700;
      color: #1e87f0;
      border-bottom: 2px solid #1e87f0;
    }

    .el-button {
      transition: all linear 0.3s;
      width: 30px;
      padding: 0;
      border: 0;
      font-size: 22px;

      &:hover {
        background: transparent;
      }

      &:focus {
        background: transparent;
      }
    }
  }

  .TopBox::-webkit-scrollbar {
    display: none;
  }

  .tableTitle {
    height: 40px;
		line-height: 40px;
		font-size: 16px;
		font-weight: 600;
		text-align: left;
		padding-left: 20px;

    .icon-shu {
      color: #59bf85;
      position: absolute;
      left: 0px;
      font-size: 24px;
      background: #59bf85;
      border-radius: 2px;
      width: 5px;
      height: 18px;
      margin: 10px 0;
    }
  }

  .videoList {
    .videoBox {
      font-size: 15px;
      margin-bottom: 30px;
      position: relative;

      .videoCover {
        width: 100%;
        /*height: 9vw;*/
        cursor: pointer;
      }

      .videoBtnS {
        width: 100%;
        height: 36px;
        line-height: 36px;

        .videoBtn {
          width: 33%;
          float: left;
          color: #000;
          cursor: pointer;
          background-color: #ececec;
          text-align: center;
        }

        .videoBtnL {
          color: #ffffff;
          background-color: #67b4ff;
        }

        .videoBtnR {
          color: #ffffff;
          background-color: #e66262;
        }

        .videoBtnQ {
          color: #ffffff;
          background-color: #e6c06d;
        }
      }
    }

    .down {
      color: #409eff;
      font-size: 12px;
      font-weight: bold;
      display: inline-block;
      margin-right: 10px;
      text-decoration: none;
    }
  }

  .CoverBox {
    position: fixed;
    text-align: center;
    background-color: #ffffff;
    width: 1100px;
    top: 50px;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    border: 1px solid #dedede;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    overflow: hidden;
    z-index: 11;
    box-shadow: 0 0 10px 2px #dedede;

    .title {
      font-size: 18px;
      text-indent: 2em;
      line-height: 40px;
      font-weight: 600;
      text-align: left;
      border-bottom: 1px solid #dedede;
    }

    .videops {
      position: absolute;
      left: 0;
      right: 0;
      top: 42px;
      bottom: 50px;
    }

    .videoCover {
      width: 100%;
      height: 100%;
    }

    video[id] {
      width: 100%;
      height: 100%;
    }

    .setBen {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      display: flex;

      a {
        text-decoration: none;
      }
    }

    .CoverBtn {
      flex: 1 1 auto;
      color: #ffffff;
      font-size: 16px;
      line-height: 50px;
      height: 50px;
      cursor: pointer;
    }

    .CoverDown {
      flex: 1 1 auto;
      background-color: #67b4ff;
      /*background-color: #999999;*/
      border-right: 1px solid #ffffff;
    }

    .CoverDel {
      flex: 1 1 auto;
      background-color: #e66262;
      /*background-color: #999999;*/
      border-right: 1px solid #ffffff;
    }

    .CoverClose {
      background-color: #999999;
    }
  }

  .excision {
    font-size: 18px;
    line-height: 50px;
    font-weight: 700;
    text-align: left;
    margin-top: 5px;
    border-bottom: 2px solid #000;
    display: flex;
    justify-content: space-between;

    span {
      display: inline-block;
      vertical-align: middle;
      max-width: 25%;
      font-size: 16px;
      font-weight: 500;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .TopBox {
      flex: 1 1 auto;
      margin-top: 10px;
    }

    .zheTime {
      margin-left: 5px;
      font-size: 12px;
      font-weight: 500;
      float: right;
    }

    .newBtn {
      min-width: 56px;
      height: 26px;
      line-height: 26px;
      padding: 0 5px;
      margin: 10px 5px 0;
      border: 1px solid #000;
      font-size: 14px;
      font-weight: 500;
      float: right;
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      border-radius: 3px;
      cursor: pointer;
    }
  }

  .content_title {
    /*float: left;*/
    margin-top: 20px;
    line-height: 40px;
    text-align: left;
    padding-left: 20px;
    font-size: 16px;
    font-weight: 600;
    position: relative;

    &.title-first {
      margin-top: 0;
    }

    .icon-shu {
      color: #59bf85;
      position: absolute;
      left: 0px;
      font-size: 24px;
      background: #59bf85;
      border-radius: 2px;
      width: 5px;
      height: 18px;
      margin: 10px 0;
    }
  }

  .bei_box {
    width: 99%;
    /* border: 1px solid #B0B7C2; */
    background-color: #ffffff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;

    .beipipei {
      width: 100px;
      height: 35px;
      margin: 10px auto;
      cursor: pointer;
    }

    .bei_top {
      margin: 0 auto;
      width: 99%;
      text-align: left;

      .file_li {
        height: 40px;
        line-height: 40px;
        border-bottom: 1px dashed #dedede;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;

        .file_yx {
          display: inline-block;
          vertical-align: top;
          margin-right: 20px;
        }

        .file_icon {
          width: 50px;
          min-width: 50px;
          font-size: 11px;
          margin-right: 10px;
          height: 24px;
          line-height: 25px;
          text-align: center;
          display: inline;
          background-color: #5f90ff;
          color: #ffffff;
          -webkit-border-radius: 3px;
          -moz-border-radius: 3px;
          border-radius: 3px;
        }

        .file_name {
          /*display: block;*/
          margin-right: 40px;
          flex: 1 1 auto;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .file_Mb {
          width: 70px;
          min-width: 70px;
          margin-right: 0;
        }

        .file_del {
          width: 50px;
          min-width: 50px;
          color: red;
          cursor: pointer;
          float: right;
          margin-right: 0;
          text-align: right;
        }

        .file_down {
          margin-right: 0;
          width: 50px;
          min-width: 50px;
          color: #00be00;
          cursor: pointer;
          float: right;
          text-align: right;
        }
      }

      .file_li:nth-last-child(1) {
        border-bottom: none;
      }
    }

    .bei_bottom {
      height: 40px;
      line-height: 40px;
      padding: 5px 15px;
      text-align: left;
      /* background-color: #E5E5E5; */
      border-radius: 0 0 5px 5px;

      .btn_file {
        /*top: 5px;
        left: 30px;*/
        position: relative;
        cursor: pointer;
        background-color: #ffffff;
        display: inline-block;
        height: 30px;
        line-height: 30px;
        font-size: 13px;
        padding: 0px 15px;
        margin-left: 10px;
        /*width: 140px;*/
        text-align: center;
        border: 1px solid #dcdfe6;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
        /* -webkit-box-shadow: 0 0 1px 2px #dedede;
        -moz-box-shadow: 0 0 1px 2px #dedede;
        box-shadow: 0 0 1px 2px #dedede; */

        .fileBtn {
          cursor: pointer;
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          opacity: 0;
        }
      }

      .add {
        height: 40px;
        width: 40px;
        margin: 60px auto;
      }
    }
  }

  .tk_top {
    height: 40px;
    line-height: 40px;
    text-indent: 2em;
    background-color: #eaedf2;

    span {
      width: 30%;
      text-align: left;
      float: right;
    }
  }

  .radioBox {
    border-bottom: 1px solid #dedede;
    padding: 0 5%;
    line-height: 40px;

    .el-radio {
      width: 100%;
      display: inline-block;
      vertical-align: middle;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .el-time {
      width: 30%;
      display: inline-block;
      vertical-align: middle;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  /*精品课,任务单*/

  .el-tabs {
    /deep/ .el-tabs__header {
      .el-tabs__item {
        font-size: 18px;
        font-weight: bold;
        color: #666;

        &.is-active {
          color: #409eff;
        }
      }

      /deep/ td,
      th,
      th.is-leaf {
        border-bottom: 1px dashed #b0b7c2 !important;
      }
    }

    .el-table {
      margin-bottom: 10px;
      border: 1px solid #b0b7c2;
      border-radius: 5px 5px 0 0;

      /deep/ td,
      th,
      th.is-leaf {
        padding: 5px 0;
        border-bottom: 1px dashed #b0b7c2 !important;
      }
    }

    /deep/ .tableHeader {
      background: #f6f6f6;

      th {
        background: #f6f6f6;
        color: #2c3e50;
      }
    }

    /deep/ .el-table__fixed-right {
      height: 100% !important; //设置高优先，以覆盖内联样式
    }

    /deep/ .el-table__body {
      tbody {
        tr {
          td:first-child:hover {
            /*text-decoration: underline;*/
            cursor: pointer;
            color: #409eff;
          }
        }
      }
    }

    .btns {
      text-align: left;
    }

    .qualityClass {
      /deep/ .el-dialog {
        position: relative;

        .el-dialog__header {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          height: 54px;

          .el-dialog__close {
            font-weight: bold;
            border-radius: 100px;
            font-size: 20px;
            color: #f00;
            border: 1px solid #f00;
          }
        }

        .el-dialog__body {
          position: absolute;
          top: 54px;
          bottom: 0;
          left: 0;
          right: 0;
          overflow: auto;
          max-height: none;
          padding: 0 20px;
        }
      }

      .editorDialog {
        /deep/ .el-dialog {
          height: 90%;

          .el-dialog__body {
            left: 20px;
            right: 20px;
            top: 54px;
            bottom: 0;
          }
        }
      }

      /*//预览打印*/

      .preview {
        .previewBtns {
          position: fixed;
          width: 150px;
          top: 55%;
          right: 10%;

          .el-button {
            width: 100%;
            display: block;
            margin-left: 0;
            margin-bottom: 30px;
          }
        }
      }

      ////表格
      .el-table {
        /deep/ .cell {
          white-space: nowrap;
        }
      }
    }
  }

  //
  .lessonImgDialog {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
    z-index: 2006;
    background: rgba(0, 0, 0, 0.3);

    .lessonImgCarousel {
      width: 1280px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);

      /deep/ .el-carousel {
        .el-carousel__arrow {
          background: rgba(255, 255, 255, 0.6);
          color: #000;
          font-size: 30px;
          font-weight: bold;
        }
      }
    }
  }

  .evaluateSave {
    margin-top: 20px;
    width: 100px;
  }
}

.card-carousel-wrapper {
  margin: 20px 0;
  height: 180px;
  color: #666a73;
  position: relative;
}

.card-carousel {
  position: absolute;
  left: 50px;
  top: 0;
  right: 50px;
  bottom: 0;
  display: flex;
  justify-content: center;
  flex: 1 1 auto;
}

.card-carousel--overflow-container {
  overflow: hidden;
}

.card-carousel--nav__left,
.card-carousel--nav__right {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  bottom: 0;
  display: inline-block;
  width: 30px;
  height: 30px;
  box-sizing: border-box;
  border-top: 5px solid #42b883;
  border-right: 5px solid #42b883;
  cursor: pointer;
  margin: 0 10px;
  transition: transform 150ms linear;
}

.card-carousel--nav__left {
  left: 0;
}

.card-carousel--nav__right {
  right: 0;
}

.card-carousel--nav__left[disabled],
.card-carousel--nav__right[disabled] {
  opacity: 0.2;
  border-color: black;
}

.card-carousel--nav__left {
  transform: rotate(-135deg);
}

.card-carousel--nav__left:active {
  transform: rotate(-135deg) scale(0.9);
}

.card-carousel--nav__right {
  transform: rotate(45deg);
}

.card-carousel--nav__right:active {
  transform: rotate(45deg) scale(0.9);
}

.card-carousel-cards {
  transition: transform 150ms ease-out;
  transform: translatex(0px);
  /*height: 300px;*/
  white-space: nowrap;
}

.card-carousel-cards .card-carousel--card {
  display: inline-block;
  margin: 0 5px;
  cursor: pointer;
  box-shadow: 0 4px 15px 0 rgba(40, 44, 53, 0.06), 0 2px 2px 0 rgba(40, 44, 53, 0.08);
  background-color: #fff;
  border-radius: 4px;
  z-index: 3;
  margin-bottom: 2px;
  position: relative;
  width: 320px;
  height: 180px;
  line-height: 180px;
}

.card-carousel-cards .card-carousel--card:first-child {
  margin-left: 0;
}

.card-carousel-cards .card-carousel--card:last-child {
  margin-right: 0;
}

.card-carousel-cards .card-carousel--card img {
  max-width: 320px;
  max-height: 180px;
  vertical-align: bottom;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  transition: opacity 150ms linear;
  user-select: none;
}

.card-carousel-cards .card-carousel--card img:hover {
  opacity: 0.5;
}

.card-carousel-cards .card-carousel--card--footer {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 40px;
  border-top: 0;
  /*padding: 7px 15px;*/
  display: flex;
  justify-content: space-between;
}

.card-carousel-cards .card-carousel--card--footer .p {
  display: block;
  margin: 0;
  margin-bottom: 2px;
  width: 40px;
  height: 40px;
  text-align: center;
  line-height: 43px;
  font-size: 30px;
  font-weight: bold;
  border-radius: 100px;
  color: #fff;
  background: rgba(0, 0, 0, 0.6);
  user-select: none;
}

.tk_pp {
  /deep/ .el-dialog__body {
    max-height: 400px;
  }
}

.upQualityClass {
  .sp {
    padding-right: 10px;
    color: #f00;
  }

  .msg {
    padding-left: 20px;
    color: #999;

    li.title {
      color: #f00;
    }
  }
}
</style>
<style lang="less">
.el-dialog__body {
  padding: 10px 20px;
  overflow-y: auto;
  overflow-x: hidden;
}

.el-radio__inner {
  border-color: #8a8a8a;
}
/**

.el-table td,
.el-table th,
.el-table th.is-leaf {
  text-align: center;
  border-bottom: 1px dashed #B0B7C2 !important;
}*/

.w-e-text img {
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/components/Detail.vue